"use strict";
/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten
Object.defineProperty(exports, "__esModule", { value: true });
exports.onUpdateUtoken = exports.onCreateUtoken = exports.onDeleteStorage = exports.onUpdateStorage = exports.onCreateStorage = exports.onDeleteUser = exports.onUpdateUser = exports.onCreateUser = exports.onDeleteNotification = exports.onUpdateNotification = exports.onCreateNotification = exports.onDeleteTransactionLog = exports.onUpdateTransactionLog = exports.onCreateTransactionLog = exports.onDeleteTransaction = exports.onUpdateTransaction = exports.onCreateTransaction = exports.onDeleteStorageTransaction = exports.onUpdateStorageTransaction = exports.onCreateStorageTransaction = exports.onDeleteBundle = exports.onUpdateBundle = exports.onCreateBundle = exports.onDeleteWhitelist = exports.onUpdateWhitelist = exports.onCreateWhitelist = exports.onDeleteMemo = exports.onUpdateMemo = exports.onCreateMemo = exports.onDeleteFolder = exports.onUpdateFolder = exports.onCreateFolder = exports.onDeleteFileVersion = exports.onUpdateFileVersion = exports.onCreateFileVersion = exports.onDeleteCollection = exports.onUpdateCollection = exports.onCreateCollection = exports.onDeleteNFT = exports.onUpdateNFT = exports.onCreateNFT = exports.onDeleteStack = exports.onUpdateStack = exports.onCreateStack = exports.onDeleteMembership = exports.onUpdateMembership = exports.onCreateMembership = exports.onDeleteVault = exports.onUpdateVault = exports.onCreateVault = void 0;
exports.onDeleteKeyMetric = exports.onUpdateKeyMetric = exports.onCreateKeyMetric = exports.onDeleteWebhookLog = exports.onUpdateWebhookLog = exports.onCreateWebhookLog = exports.onDeleteWebhook = exports.onUpdateWebhook = exports.onCreateWebhook = exports.onDeleteApiKey = exports.onUpdateApiKey = exports.onCreateApiKey = exports.onDeleteOrganisation = exports.onUpdateOrganisation = exports.onCreateOrganisation = exports.onDeletePaymentTransaction = exports.onUpdatePaymentTransaction = exports.onCreatePaymentTransaction = exports.onDeleteUtoken = void 0;
exports.onCreateVault = `subscription OnCreateVault($filter: ModelSubscriptionVaultFilterInput) {
  onCreateVault(filter: $filter) {
    id
    membership {
      items {
        id
        address
        email
        vaultId
        vault {
          id
          membership {
            items {
              id
              address
              email
              vaultId
              data
              expiresAt
              _ttl
              encPublicSigningKey
              message
              owner
              role
              status
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          admin
          data
          description
          name
          owner
          public
          cloud
          blocked
          size
          status
          tags
          termsOfAccess
          createdAt
          updatedAt
          __typename
        }
        memberDetails {
          address
          email
          referralId
          avatar
          profileName
          publicKey
          publicSigningKey
          metadata
          orgId
          orgRole
          _ttl
          createdAt
          updatedAt
          organisationUsersId
          __typename
        }
        data
        expiresAt
        _ttl
        keys {
          encPrivateKey
          encPublicKey
          publicKey
          __typename
        }
        encPublicSigningKey
        message
        owner
        role
        status
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    admin
    data
    description
    name
    owner
    public
    cloud
    blocked
    size
    status
    tags
    termsOfAccess
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.onUpdateVault = `subscription OnUpdateVault($filter: ModelSubscriptionVaultFilterInput) {
  onUpdateVault(filter: $filter) {
    id
    membership {
      items {
        id
        address
        email
        vaultId
        vault {
          id
          membership {
            items {
              id
              address
              email
              vaultId
              data
              expiresAt
              _ttl
              encPublicSigningKey
              message
              owner
              role
              status
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          admin
          data
          description
          name
          owner
          public
          cloud
          blocked
          size
          status
          tags
          termsOfAccess
          createdAt
          updatedAt
          __typename
        }
        memberDetails {
          address
          email
          referralId
          avatar
          profileName
          publicKey
          publicSigningKey
          metadata
          orgId
          orgRole
          _ttl
          createdAt
          updatedAt
          organisationUsersId
          __typename
        }
        data
        expiresAt
        _ttl
        keys {
          encPrivateKey
          encPublicKey
          publicKey
          __typename
        }
        encPublicSigningKey
        message
        owner
        role
        status
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    admin
    data
    description
    name
    owner
    public
    cloud
    blocked
    size
    status
    tags
    termsOfAccess
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.onDeleteVault = `subscription OnDeleteVault($filter: ModelSubscriptionVaultFilterInput) {
  onDeleteVault(filter: $filter) {
    id
    membership {
      items {
        id
        address
        email
        vaultId
        vault {
          id
          membership {
            items {
              id
              address
              email
              vaultId
              data
              expiresAt
              _ttl
              encPublicSigningKey
              message
              owner
              role
              status
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          admin
          data
          description
          name
          owner
          public
          cloud
          blocked
          size
          status
          tags
          termsOfAccess
          createdAt
          updatedAt
          __typename
        }
        memberDetails {
          address
          email
          referralId
          avatar
          profileName
          publicKey
          publicSigningKey
          metadata
          orgId
          orgRole
          _ttl
          createdAt
          updatedAt
          organisationUsersId
          __typename
        }
        data
        expiresAt
        _ttl
        keys {
          encPrivateKey
          encPublicKey
          publicKey
          __typename
        }
        encPublicSigningKey
        message
        owner
        role
        status
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    admin
    data
    description
    name
    owner
    public
    cloud
    blocked
    size
    status
    tags
    termsOfAccess
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.onCreateMembership = `subscription OnCreateMembership(
  $filter: ModelSubscriptionMembershipFilterInput
) {
  onCreateMembership(filter: $filter) {
    id
    address
    email
    vaultId
    vault {
      id
      membership {
        items {
          id
          address
          email
          vaultId
          vault {
            id
            membership {
              nextToken
              __typename
            }
            admin
            data
            description
            name
            owner
            public
            cloud
            blocked
            size
            status
            tags
            termsOfAccess
            createdAt
            updatedAt
            __typename
          }
          memberDetails {
            address
            email
            referralId
            avatar
            profileName
            publicKey
            publicSigningKey
            metadata
            orgId
            orgRole
            _ttl
            createdAt
            updatedAt
            organisationUsersId
            __typename
          }
          data
          expiresAt
          _ttl
          keys {
            encPrivateKey
            encPublicKey
            publicKey
            __typename
          }
          encPublicSigningKey
          message
          owner
          role
          status
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      admin
      data
      description
      name
      owner
      public
      cloud
      blocked
      size
      status
      tags
      termsOfAccess
      createdAt
      updatedAt
      __typename
    }
    memberDetails {
      address
      email
      referralId
      avatar
      profileName
      publicKey
      publicSigningKey
      metadata
      orgId
      orgRole
      _ttl
      createdAt
      updatedAt
      organisationUsersId
      __typename
    }
    data
    expiresAt
    _ttl
    keys {
      encPrivateKey
      encPublicKey
      publicKey
      __typename
    }
    encPublicSigningKey
    message
    owner
    role
    status
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.onUpdateMembership = `subscription OnUpdateMembership(
  $filter: ModelSubscriptionMembershipFilterInput
) {
  onUpdateMembership(filter: $filter) {
    id
    address
    email
    vaultId
    vault {
      id
      membership {
        items {
          id
          address
          email
          vaultId
          vault {
            id
            membership {
              nextToken
              __typename
            }
            admin
            data
            description
            name
            owner
            public
            cloud
            blocked
            size
            status
            tags
            termsOfAccess
            createdAt
            updatedAt
            __typename
          }
          memberDetails {
            address
            email
            referralId
            avatar
            profileName
            publicKey
            publicSigningKey
            metadata
            orgId
            orgRole
            _ttl
            createdAt
            updatedAt
            organisationUsersId
            __typename
          }
          data
          expiresAt
          _ttl
          keys {
            encPrivateKey
            encPublicKey
            publicKey
            __typename
          }
          encPublicSigningKey
          message
          owner
          role
          status
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      admin
      data
      description
      name
      owner
      public
      cloud
      blocked
      size
      status
      tags
      termsOfAccess
      createdAt
      updatedAt
      __typename
    }
    memberDetails {
      address
      email
      referralId
      avatar
      profileName
      publicKey
      publicSigningKey
      metadata
      orgId
      orgRole
      _ttl
      createdAt
      updatedAt
      organisationUsersId
      __typename
    }
    data
    expiresAt
    _ttl
    keys {
      encPrivateKey
      encPublicKey
      publicKey
      __typename
    }
    encPublicSigningKey
    message
    owner
    role
    status
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.onDeleteMembership = `subscription OnDeleteMembership(
  $filter: ModelSubscriptionMembershipFilterInput
) {
  onDeleteMembership(filter: $filter) {
    id
    address
    email
    vaultId
    vault {
      id
      membership {
        items {
          id
          address
          email
          vaultId
          vault {
            id
            membership {
              nextToken
              __typename
            }
            admin
            data
            description
            name
            owner
            public
            cloud
            blocked
            size
            status
            tags
            termsOfAccess
            createdAt
            updatedAt
            __typename
          }
          memberDetails {
            address
            email
            referralId
            avatar
            profileName
            publicKey
            publicSigningKey
            metadata
            orgId
            orgRole
            _ttl
            createdAt
            updatedAt
            organisationUsersId
            __typename
          }
          data
          expiresAt
          _ttl
          keys {
            encPrivateKey
            encPublicKey
            publicKey
            __typename
          }
          encPublicSigningKey
          message
          owner
          role
          status
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      admin
      data
      description
      name
      owner
      public
      cloud
      blocked
      size
      status
      tags
      termsOfAccess
      createdAt
      updatedAt
      __typename
    }
    memberDetails {
      address
      email
      referralId
      avatar
      profileName
      publicKey
      publicSigningKey
      metadata
      orgId
      orgRole
      _ttl
      createdAt
      updatedAt
      organisationUsersId
      __typename
    }
    data
    expiresAt
    _ttl
    keys {
      encPrivateKey
      encPublicKey
      publicKey
      __typename
    }
    encPublicSigningKey
    message
    owner
    role
    status
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.onCreateStack = `subscription OnCreateStack($filter: ModelSubscriptionStackFilterInput) {
  onCreateStack(filter: $filter) {
    id
    versions {
      items {
        id
        nodeId
        owner
        storageTransactionId
        storageTransaction {
          id
          owner
          txId
          txFee
          dataItemId
          fileVersion {
            id
            nodeId
            owner
            storageTransactionId
            storageTransaction {
              id
              owner
              txId
              txFee
              dataItemId
              bundleId
              class
              vaultId
              nodeId
              nodeType
              status
              type
              uploadCount
              size
              verificationId
              verificationCount
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            name
            chunkSize
            numberOfChunks
            resourceUri
            size
            type
            ucm
            udl {
              currency
              expires
              license
              paymentAddress
              paymentMode
              unknownUsageRights
              __typename
            }
            status
            external
            nodeType
            tags
            class
            _ttl
            createdAt
            updatedAt
            __typename
          }
          bundleId
          bundle {
            id
            txId
            txFee
            status
            dataItem {
              nextToken
              __typename
            }
            uploadCount
            dataItemsCount
            size
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          members {
            items {
              id
              address
              email
              vaultId
              data
              expiresAt
              _ttl
              encPublicSigningKey
              message
              owner
              role
              status
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          class
          vaultId
          nodeId
          nodeType
          status
          type
          uploadCount
          size
          verificationId
          verificationCount
          signedBy
          signature
          payedBy
          createdAt
          updatedAt
          __typename
        }
        name
        chunkSize
        numberOfChunks
        resourceUri
        size
        type
        ucm
        udl {
          commercialUses {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          currency
          derivations {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          dataModelTrainings {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          expires
          license
          licenseFee {
            type
            value
            __typename
          }
          paymentAddress
          paymentMode
          unknownUsageRights
          __typename
        }
        status
        external
        nodeType
        tags
        class
        _ttl
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    vaultId
    parentId
    name
    owner
    status
    data
    tags
    size
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.onUpdateStack = `subscription OnUpdateStack($filter: ModelSubscriptionStackFilterInput) {
  onUpdateStack(filter: $filter) {
    id
    versions {
      items {
        id
        nodeId
        owner
        storageTransactionId
        storageTransaction {
          id
          owner
          txId
          txFee
          dataItemId
          fileVersion {
            id
            nodeId
            owner
            storageTransactionId
            storageTransaction {
              id
              owner
              txId
              txFee
              dataItemId
              bundleId
              class
              vaultId
              nodeId
              nodeType
              status
              type
              uploadCount
              size
              verificationId
              verificationCount
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            name
            chunkSize
            numberOfChunks
            resourceUri
            size
            type
            ucm
            udl {
              currency
              expires
              license
              paymentAddress
              paymentMode
              unknownUsageRights
              __typename
            }
            status
            external
            nodeType
            tags
            class
            _ttl
            createdAt
            updatedAt
            __typename
          }
          bundleId
          bundle {
            id
            txId
            txFee
            status
            dataItem {
              nextToken
              __typename
            }
            uploadCount
            dataItemsCount
            size
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          members {
            items {
              id
              address
              email
              vaultId
              data
              expiresAt
              _ttl
              encPublicSigningKey
              message
              owner
              role
              status
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          class
          vaultId
          nodeId
          nodeType
          status
          type
          uploadCount
          size
          verificationId
          verificationCount
          signedBy
          signature
          payedBy
          createdAt
          updatedAt
          __typename
        }
        name
        chunkSize
        numberOfChunks
        resourceUri
        size
        type
        ucm
        udl {
          commercialUses {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          currency
          derivations {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          dataModelTrainings {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          expires
          license
          licenseFee {
            type
            value
            __typename
          }
          paymentAddress
          paymentMode
          unknownUsageRights
          __typename
        }
        status
        external
        nodeType
        tags
        class
        _ttl
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    vaultId
    parentId
    name
    owner
    status
    data
    tags
    size
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.onDeleteStack = `subscription OnDeleteStack($filter: ModelSubscriptionStackFilterInput) {
  onDeleteStack(filter: $filter) {
    id
    versions {
      items {
        id
        nodeId
        owner
        storageTransactionId
        storageTransaction {
          id
          owner
          txId
          txFee
          dataItemId
          fileVersion {
            id
            nodeId
            owner
            storageTransactionId
            storageTransaction {
              id
              owner
              txId
              txFee
              dataItemId
              bundleId
              class
              vaultId
              nodeId
              nodeType
              status
              type
              uploadCount
              size
              verificationId
              verificationCount
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            name
            chunkSize
            numberOfChunks
            resourceUri
            size
            type
            ucm
            udl {
              currency
              expires
              license
              paymentAddress
              paymentMode
              unknownUsageRights
              __typename
            }
            status
            external
            nodeType
            tags
            class
            _ttl
            createdAt
            updatedAt
            __typename
          }
          bundleId
          bundle {
            id
            txId
            txFee
            status
            dataItem {
              nextToken
              __typename
            }
            uploadCount
            dataItemsCount
            size
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          members {
            items {
              id
              address
              email
              vaultId
              data
              expiresAt
              _ttl
              encPublicSigningKey
              message
              owner
              role
              status
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          class
          vaultId
          nodeId
          nodeType
          status
          type
          uploadCount
          size
          verificationId
          verificationCount
          signedBy
          signature
          payedBy
          createdAt
          updatedAt
          __typename
        }
        name
        chunkSize
        numberOfChunks
        resourceUri
        size
        type
        ucm
        udl {
          commercialUses {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          currency
          derivations {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          dataModelTrainings {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          expires
          license
          licenseFee {
            type
            value
            __typename
          }
          paymentAddress
          paymentMode
          unknownUsageRights
          __typename
        }
        status
        external
        nodeType
        tags
        class
        _ttl
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    vaultId
    parentId
    name
    owner
    status
    data
    tags
    size
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.onCreateNFT = `subscription OnCreateNFT($filter: ModelSubscriptionNFTFilterInput) {
  onCreateNFT(filter: $filter) {
    id
    vaultId
    parentId
    name
    owner
    assetId
    asset {
      id
      nodeId
      owner
      storageTransactionId
      storageTransaction {
        id
        owner
        txId
        txFee
        dataItemId
        fileVersion {
          id
          nodeId
          owner
          storageTransactionId
          storageTransaction {
            id
            owner
            txId
            txFee
            dataItemId
            fileVersion {
              id
              nodeId
              owner
              storageTransactionId
              name
              chunkSize
              numberOfChunks
              resourceUri
              size
              type
              ucm
              status
              external
              nodeType
              tags
              class
              _ttl
              createdAt
              updatedAt
              __typename
            }
            bundleId
            bundle {
              id
              txId
              txFee
              status
              uploadCount
              dataItemsCount
              size
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            members {
              nextToken
              __typename
            }
            class
            vaultId
            nodeId
            nodeType
            status
            type
            uploadCount
            size
            verificationId
            verificationCount
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          name
          chunkSize
          numberOfChunks
          resourceUri
          size
          type
          ucm
          udl {
            commercialUses {
              type
              value
              __typename
            }
            currency
            derivations {
              type
              value
              __typename
            }
            dataModelTrainings {
              type
              value
              __typename
            }
            expires
            license
            licenseFee {
              type
              value
              __typename
            }
            paymentAddress
            paymentMode
            unknownUsageRights
            __typename
          }
          status
          external
          nodeType
          tags
          class
          _ttl
          createdAt
          updatedAt
          __typename
        }
        bundleId
        bundle {
          id
          txId
          txFee
          status
          dataItem {
            items {
              id
              owner
              txId
              txFee
              dataItemId
              bundleId
              class
              vaultId
              nodeId
              nodeType
              status
              type
              uploadCount
              size
              verificationId
              verificationCount
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          uploadCount
          dataItemsCount
          size
          signedBy
          signature
          payedBy
          createdAt
          updatedAt
          __typename
        }
        members {
          items {
            id
            address
            email
            vaultId
            vault {
              id
              admin
              data
              description
              name
              owner
              public
              cloud
              blocked
              size
              status
              tags
              termsOfAccess
              createdAt
              updatedAt
              __typename
            }
            memberDetails {
              address
              email
              referralId
              avatar
              profileName
              publicKey
              publicSigningKey
              metadata
              orgId
              orgRole
              _ttl
              createdAt
              updatedAt
              organisationUsersId
              __typename
            }
            data
            expiresAt
            _ttl
            keys {
              encPrivateKey
              encPublicKey
              publicKey
              __typename
            }
            encPublicSigningKey
            message
            owner
            role
            status
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        class
        vaultId
        nodeId
        nodeType
        status
        type
        uploadCount
        size
        verificationId
        verificationCount
        signedBy
        signature
        payedBy
        createdAt
        updatedAt
        __typename
      }
      name
      chunkSize
      numberOfChunks
      resourceUri
      size
      type
      ucm
      udl {
        commercialUses {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        currency
        derivations {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        dataModelTrainings {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        expires
        license
        licenseFee {
          type
          value
          __typename
        }
        paymentAddress
        paymentMode
        unknownUsageRights
        __typename
      }
      status
      external
      nodeType
      tags
      class
      _ttl
      createdAt
      updatedAt
      __typename
    }
    thumbnailId
    thumbnail {
      id
      nodeId
      owner
      storageTransactionId
      storageTransaction {
        id
        owner
        txId
        txFee
        dataItemId
        fileVersion {
          id
          nodeId
          owner
          storageTransactionId
          storageTransaction {
            id
            owner
            txId
            txFee
            dataItemId
            fileVersion {
              id
              nodeId
              owner
              storageTransactionId
              name
              chunkSize
              numberOfChunks
              resourceUri
              size
              type
              ucm
              status
              external
              nodeType
              tags
              class
              _ttl
              createdAt
              updatedAt
              __typename
            }
            bundleId
            bundle {
              id
              txId
              txFee
              status
              uploadCount
              dataItemsCount
              size
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            members {
              nextToken
              __typename
            }
            class
            vaultId
            nodeId
            nodeType
            status
            type
            uploadCount
            size
            verificationId
            verificationCount
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          name
          chunkSize
          numberOfChunks
          resourceUri
          size
          type
          ucm
          udl {
            commercialUses {
              type
              value
              __typename
            }
            currency
            derivations {
              type
              value
              __typename
            }
            dataModelTrainings {
              type
              value
              __typename
            }
            expires
            license
            licenseFee {
              type
              value
              __typename
            }
            paymentAddress
            paymentMode
            unknownUsageRights
            __typename
          }
          status
          external
          nodeType
          tags
          class
          _ttl
          createdAt
          updatedAt
          __typename
        }
        bundleId
        bundle {
          id
          txId
          txFee
          status
          dataItem {
            items {
              id
              owner
              txId
              txFee
              dataItemId
              bundleId
              class
              vaultId
              nodeId
              nodeType
              status
              type
              uploadCount
              size
              verificationId
              verificationCount
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          uploadCount
          dataItemsCount
          size
          signedBy
          signature
          payedBy
          createdAt
          updatedAt
          __typename
        }
        members {
          items {
            id
            address
            email
            vaultId
            vault {
              id
              admin
              data
              description
              name
              owner
              public
              cloud
              blocked
              size
              status
              tags
              termsOfAccess
              createdAt
              updatedAt
              __typename
            }
            memberDetails {
              address
              email
              referralId
              avatar
              profileName
              publicKey
              publicSigningKey
              metadata
              orgId
              orgRole
              _ttl
              createdAt
              updatedAt
              organisationUsersId
              __typename
            }
            data
            expiresAt
            _ttl
            keys {
              encPrivateKey
              encPublicKey
              publicKey
              __typename
            }
            encPublicSigningKey
            message
            owner
            role
            status
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        class
        vaultId
        nodeId
        nodeType
        status
        type
        uploadCount
        size
        verificationId
        verificationCount
        signedBy
        signature
        payedBy
        createdAt
        updatedAt
        __typename
      }
      name
      chunkSize
      numberOfChunks
      resourceUri
      size
      type
      ucm
      udl {
        commercialUses {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        currency
        derivations {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        dataModelTrainings {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        expires
        license
        licenseFee {
          type
          value
          __typename
        }
        paymentAddress
        paymentMode
        unknownUsageRights
        __typename
      }
      status
      external
      nodeType
      tags
      class
      _ttl
      createdAt
      updatedAt
      __typename
    }
    balances
    claimable {
      from
      qty
      to
      txID
      __typename
    }
    creator
    ticker
    description
    collection
    data
    status
    tags
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.onUpdateNFT = `subscription OnUpdateNFT($filter: ModelSubscriptionNFTFilterInput) {
  onUpdateNFT(filter: $filter) {
    id
    vaultId
    parentId
    name
    owner
    assetId
    asset {
      id
      nodeId
      owner
      storageTransactionId
      storageTransaction {
        id
        owner
        txId
        txFee
        dataItemId
        fileVersion {
          id
          nodeId
          owner
          storageTransactionId
          storageTransaction {
            id
            owner
            txId
            txFee
            dataItemId
            fileVersion {
              id
              nodeId
              owner
              storageTransactionId
              name
              chunkSize
              numberOfChunks
              resourceUri
              size
              type
              ucm
              status
              external
              nodeType
              tags
              class
              _ttl
              createdAt
              updatedAt
              __typename
            }
            bundleId
            bundle {
              id
              txId
              txFee
              status
              uploadCount
              dataItemsCount
              size
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            members {
              nextToken
              __typename
            }
            class
            vaultId
            nodeId
            nodeType
            status
            type
            uploadCount
            size
            verificationId
            verificationCount
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          name
          chunkSize
          numberOfChunks
          resourceUri
          size
          type
          ucm
          udl {
            commercialUses {
              type
              value
              __typename
            }
            currency
            derivations {
              type
              value
              __typename
            }
            dataModelTrainings {
              type
              value
              __typename
            }
            expires
            license
            licenseFee {
              type
              value
              __typename
            }
            paymentAddress
            paymentMode
            unknownUsageRights
            __typename
          }
          status
          external
          nodeType
          tags
          class
          _ttl
          createdAt
          updatedAt
          __typename
        }
        bundleId
        bundle {
          id
          txId
          txFee
          status
          dataItem {
            items {
              id
              owner
              txId
              txFee
              dataItemId
              bundleId
              class
              vaultId
              nodeId
              nodeType
              status
              type
              uploadCount
              size
              verificationId
              verificationCount
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          uploadCount
          dataItemsCount
          size
          signedBy
          signature
          payedBy
          createdAt
          updatedAt
          __typename
        }
        members {
          items {
            id
            address
            email
            vaultId
            vault {
              id
              admin
              data
              description
              name
              owner
              public
              cloud
              blocked
              size
              status
              tags
              termsOfAccess
              createdAt
              updatedAt
              __typename
            }
            memberDetails {
              address
              email
              referralId
              avatar
              profileName
              publicKey
              publicSigningKey
              metadata
              orgId
              orgRole
              _ttl
              createdAt
              updatedAt
              organisationUsersId
              __typename
            }
            data
            expiresAt
            _ttl
            keys {
              encPrivateKey
              encPublicKey
              publicKey
              __typename
            }
            encPublicSigningKey
            message
            owner
            role
            status
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        class
        vaultId
        nodeId
        nodeType
        status
        type
        uploadCount
        size
        verificationId
        verificationCount
        signedBy
        signature
        payedBy
        createdAt
        updatedAt
        __typename
      }
      name
      chunkSize
      numberOfChunks
      resourceUri
      size
      type
      ucm
      udl {
        commercialUses {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        currency
        derivations {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        dataModelTrainings {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        expires
        license
        licenseFee {
          type
          value
          __typename
        }
        paymentAddress
        paymentMode
        unknownUsageRights
        __typename
      }
      status
      external
      nodeType
      tags
      class
      _ttl
      createdAt
      updatedAt
      __typename
    }
    thumbnailId
    thumbnail {
      id
      nodeId
      owner
      storageTransactionId
      storageTransaction {
        id
        owner
        txId
        txFee
        dataItemId
        fileVersion {
          id
          nodeId
          owner
          storageTransactionId
          storageTransaction {
            id
            owner
            txId
            txFee
            dataItemId
            fileVersion {
              id
              nodeId
              owner
              storageTransactionId
              name
              chunkSize
              numberOfChunks
              resourceUri
              size
              type
              ucm
              status
              external
              nodeType
              tags
              class
              _ttl
              createdAt
              updatedAt
              __typename
            }
            bundleId
            bundle {
              id
              txId
              txFee
              status
              uploadCount
              dataItemsCount
              size
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            members {
              nextToken
              __typename
            }
            class
            vaultId
            nodeId
            nodeType
            status
            type
            uploadCount
            size
            verificationId
            verificationCount
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          name
          chunkSize
          numberOfChunks
          resourceUri
          size
          type
          ucm
          udl {
            commercialUses {
              type
              value
              __typename
            }
            currency
            derivations {
              type
              value
              __typename
            }
            dataModelTrainings {
              type
              value
              __typename
            }
            expires
            license
            licenseFee {
              type
              value
              __typename
            }
            paymentAddress
            paymentMode
            unknownUsageRights
            __typename
          }
          status
          external
          nodeType
          tags
          class
          _ttl
          createdAt
          updatedAt
          __typename
        }
        bundleId
        bundle {
          id
          txId
          txFee
          status
          dataItem {
            items {
              id
              owner
              txId
              txFee
              dataItemId
              bundleId
              class
              vaultId
              nodeId
              nodeType
              status
              type
              uploadCount
              size
              verificationId
              verificationCount
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          uploadCount
          dataItemsCount
          size
          signedBy
          signature
          payedBy
          createdAt
          updatedAt
          __typename
        }
        members {
          items {
            id
            address
            email
            vaultId
            vault {
              id
              admin
              data
              description
              name
              owner
              public
              cloud
              blocked
              size
              status
              tags
              termsOfAccess
              createdAt
              updatedAt
              __typename
            }
            memberDetails {
              address
              email
              referralId
              avatar
              profileName
              publicKey
              publicSigningKey
              metadata
              orgId
              orgRole
              _ttl
              createdAt
              updatedAt
              organisationUsersId
              __typename
            }
            data
            expiresAt
            _ttl
            keys {
              encPrivateKey
              encPublicKey
              publicKey
              __typename
            }
            encPublicSigningKey
            message
            owner
            role
            status
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        class
        vaultId
        nodeId
        nodeType
        status
        type
        uploadCount
        size
        verificationId
        verificationCount
        signedBy
        signature
        payedBy
        createdAt
        updatedAt
        __typename
      }
      name
      chunkSize
      numberOfChunks
      resourceUri
      size
      type
      ucm
      udl {
        commercialUses {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        currency
        derivations {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        dataModelTrainings {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        expires
        license
        licenseFee {
          type
          value
          __typename
        }
        paymentAddress
        paymentMode
        unknownUsageRights
        __typename
      }
      status
      external
      nodeType
      tags
      class
      _ttl
      createdAt
      updatedAt
      __typename
    }
    balances
    claimable {
      from
      qty
      to
      txID
      __typename
    }
    creator
    ticker
    description
    collection
    data
    status
    tags
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.onDeleteNFT = `subscription OnDeleteNFT($filter: ModelSubscriptionNFTFilterInput) {
  onDeleteNFT(filter: $filter) {
    id
    vaultId
    parentId
    name
    owner
    assetId
    asset {
      id
      nodeId
      owner
      storageTransactionId
      storageTransaction {
        id
        owner
        txId
        txFee
        dataItemId
        fileVersion {
          id
          nodeId
          owner
          storageTransactionId
          storageTransaction {
            id
            owner
            txId
            txFee
            dataItemId
            fileVersion {
              id
              nodeId
              owner
              storageTransactionId
              name
              chunkSize
              numberOfChunks
              resourceUri
              size
              type
              ucm
              status
              external
              nodeType
              tags
              class
              _ttl
              createdAt
              updatedAt
              __typename
            }
            bundleId
            bundle {
              id
              txId
              txFee
              status
              uploadCount
              dataItemsCount
              size
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            members {
              nextToken
              __typename
            }
            class
            vaultId
            nodeId
            nodeType
            status
            type
            uploadCount
            size
            verificationId
            verificationCount
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          name
          chunkSize
          numberOfChunks
          resourceUri
          size
          type
          ucm
          udl {
            commercialUses {
              type
              value
              __typename
            }
            currency
            derivations {
              type
              value
              __typename
            }
            dataModelTrainings {
              type
              value
              __typename
            }
            expires
            license
            licenseFee {
              type
              value
              __typename
            }
            paymentAddress
            paymentMode
            unknownUsageRights
            __typename
          }
          status
          external
          nodeType
          tags
          class
          _ttl
          createdAt
          updatedAt
          __typename
        }
        bundleId
        bundle {
          id
          txId
          txFee
          status
          dataItem {
            items {
              id
              owner
              txId
              txFee
              dataItemId
              bundleId
              class
              vaultId
              nodeId
              nodeType
              status
              type
              uploadCount
              size
              verificationId
              verificationCount
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          uploadCount
          dataItemsCount
          size
          signedBy
          signature
          payedBy
          createdAt
          updatedAt
          __typename
        }
        members {
          items {
            id
            address
            email
            vaultId
            vault {
              id
              admin
              data
              description
              name
              owner
              public
              cloud
              blocked
              size
              status
              tags
              termsOfAccess
              createdAt
              updatedAt
              __typename
            }
            memberDetails {
              address
              email
              referralId
              avatar
              profileName
              publicKey
              publicSigningKey
              metadata
              orgId
              orgRole
              _ttl
              createdAt
              updatedAt
              organisationUsersId
              __typename
            }
            data
            expiresAt
            _ttl
            keys {
              encPrivateKey
              encPublicKey
              publicKey
              __typename
            }
            encPublicSigningKey
            message
            owner
            role
            status
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        class
        vaultId
        nodeId
        nodeType
        status
        type
        uploadCount
        size
        verificationId
        verificationCount
        signedBy
        signature
        payedBy
        createdAt
        updatedAt
        __typename
      }
      name
      chunkSize
      numberOfChunks
      resourceUri
      size
      type
      ucm
      udl {
        commercialUses {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        currency
        derivations {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        dataModelTrainings {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        expires
        license
        licenseFee {
          type
          value
          __typename
        }
        paymentAddress
        paymentMode
        unknownUsageRights
        __typename
      }
      status
      external
      nodeType
      tags
      class
      _ttl
      createdAt
      updatedAt
      __typename
    }
    thumbnailId
    thumbnail {
      id
      nodeId
      owner
      storageTransactionId
      storageTransaction {
        id
        owner
        txId
        txFee
        dataItemId
        fileVersion {
          id
          nodeId
          owner
          storageTransactionId
          storageTransaction {
            id
            owner
            txId
            txFee
            dataItemId
            fileVersion {
              id
              nodeId
              owner
              storageTransactionId
              name
              chunkSize
              numberOfChunks
              resourceUri
              size
              type
              ucm
              status
              external
              nodeType
              tags
              class
              _ttl
              createdAt
              updatedAt
              __typename
            }
            bundleId
            bundle {
              id
              txId
              txFee
              status
              uploadCount
              dataItemsCount
              size
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            members {
              nextToken
              __typename
            }
            class
            vaultId
            nodeId
            nodeType
            status
            type
            uploadCount
            size
            verificationId
            verificationCount
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          name
          chunkSize
          numberOfChunks
          resourceUri
          size
          type
          ucm
          udl {
            commercialUses {
              type
              value
              __typename
            }
            currency
            derivations {
              type
              value
              __typename
            }
            dataModelTrainings {
              type
              value
              __typename
            }
            expires
            license
            licenseFee {
              type
              value
              __typename
            }
            paymentAddress
            paymentMode
            unknownUsageRights
            __typename
          }
          status
          external
          nodeType
          tags
          class
          _ttl
          createdAt
          updatedAt
          __typename
        }
        bundleId
        bundle {
          id
          txId
          txFee
          status
          dataItem {
            items {
              id
              owner
              txId
              txFee
              dataItemId
              bundleId
              class
              vaultId
              nodeId
              nodeType
              status
              type
              uploadCount
              size
              verificationId
              verificationCount
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          uploadCount
          dataItemsCount
          size
          signedBy
          signature
          payedBy
          createdAt
          updatedAt
          __typename
        }
        members {
          items {
            id
            address
            email
            vaultId
            vault {
              id
              admin
              data
              description
              name
              owner
              public
              cloud
              blocked
              size
              status
              tags
              termsOfAccess
              createdAt
              updatedAt
              __typename
            }
            memberDetails {
              address
              email
              referralId
              avatar
              profileName
              publicKey
              publicSigningKey
              metadata
              orgId
              orgRole
              _ttl
              createdAt
              updatedAt
              organisationUsersId
              __typename
            }
            data
            expiresAt
            _ttl
            keys {
              encPrivateKey
              encPublicKey
              publicKey
              __typename
            }
            encPublicSigningKey
            message
            owner
            role
            status
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        class
        vaultId
        nodeId
        nodeType
        status
        type
        uploadCount
        size
        verificationId
        verificationCount
        signedBy
        signature
        payedBy
        createdAt
        updatedAt
        __typename
      }
      name
      chunkSize
      numberOfChunks
      resourceUri
      size
      type
      ucm
      udl {
        commercialUses {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        currency
        derivations {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        dataModelTrainings {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        expires
        license
        licenseFee {
          type
          value
          __typename
        }
        paymentAddress
        paymentMode
        unknownUsageRights
        __typename
      }
      status
      external
      nodeType
      tags
      class
      _ttl
      createdAt
      updatedAt
      __typename
    }
    balances
    claimable {
      from
      qty
      to
      txID
      __typename
    }
    creator
    ticker
    description
    collection
    data
    status
    tags
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.onCreateCollection = `subscription OnCreateCollection(
  $filter: ModelSubscriptionCollectionFilterInput
) {
  onCreateCollection(filter: $filter) {
    id
    vaultId
    parentId
    name
    description
    owner
    bannerId
    banner {
      id
      nodeId
      owner
      storageTransactionId
      storageTransaction {
        id
        owner
        txId
        txFee
        dataItemId
        fileVersion {
          id
          nodeId
          owner
          storageTransactionId
          storageTransaction {
            id
            owner
            txId
            txFee
            dataItemId
            fileVersion {
              id
              nodeId
              owner
              storageTransactionId
              name
              chunkSize
              numberOfChunks
              resourceUri
              size
              type
              ucm
              status
              external
              nodeType
              tags
              class
              _ttl
              createdAt
              updatedAt
              __typename
            }
            bundleId
            bundle {
              id
              txId
              txFee
              status
              uploadCount
              dataItemsCount
              size
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            members {
              nextToken
              __typename
            }
            class
            vaultId
            nodeId
            nodeType
            status
            type
            uploadCount
            size
            verificationId
            verificationCount
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          name
          chunkSize
          numberOfChunks
          resourceUri
          size
          type
          ucm
          udl {
            commercialUses {
              type
              value
              __typename
            }
            currency
            derivations {
              type
              value
              __typename
            }
            dataModelTrainings {
              type
              value
              __typename
            }
            expires
            license
            licenseFee {
              type
              value
              __typename
            }
            paymentAddress
            paymentMode
            unknownUsageRights
            __typename
          }
          status
          external
          nodeType
          tags
          class
          _ttl
          createdAt
          updatedAt
          __typename
        }
        bundleId
        bundle {
          id
          txId
          txFee
          status
          dataItem {
            items {
              id
              owner
              txId
              txFee
              dataItemId
              bundleId
              class
              vaultId
              nodeId
              nodeType
              status
              type
              uploadCount
              size
              verificationId
              verificationCount
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          uploadCount
          dataItemsCount
          size
          signedBy
          signature
          payedBy
          createdAt
          updatedAt
          __typename
        }
        members {
          items {
            id
            address
            email
            vaultId
            vault {
              id
              admin
              data
              description
              name
              owner
              public
              cloud
              blocked
              size
              status
              tags
              termsOfAccess
              createdAt
              updatedAt
              __typename
            }
            memberDetails {
              address
              email
              referralId
              avatar
              profileName
              publicKey
              publicSigningKey
              metadata
              orgId
              orgRole
              _ttl
              createdAt
              updatedAt
              organisationUsersId
              __typename
            }
            data
            expiresAt
            _ttl
            keys {
              encPrivateKey
              encPublicKey
              publicKey
              __typename
            }
            encPublicSigningKey
            message
            owner
            role
            status
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        class
        vaultId
        nodeId
        nodeType
        status
        type
        uploadCount
        size
        verificationId
        verificationCount
        signedBy
        signature
        payedBy
        createdAt
        updatedAt
        __typename
      }
      name
      chunkSize
      numberOfChunks
      resourceUri
      size
      type
      ucm
      udl {
        commercialUses {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        currency
        derivations {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        dataModelTrainings {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        expires
        license
        licenseFee {
          type
          value
          __typename
        }
        paymentAddress
        paymentMode
        unknownUsageRights
        __typename
      }
      status
      external
      nodeType
      tags
      class
      _ttl
      createdAt
      updatedAt
      __typename
    }
    thumbnailId
    thumbnail {
      id
      nodeId
      owner
      storageTransactionId
      storageTransaction {
        id
        owner
        txId
        txFee
        dataItemId
        fileVersion {
          id
          nodeId
          owner
          storageTransactionId
          storageTransaction {
            id
            owner
            txId
            txFee
            dataItemId
            fileVersion {
              id
              nodeId
              owner
              storageTransactionId
              name
              chunkSize
              numberOfChunks
              resourceUri
              size
              type
              ucm
              status
              external
              nodeType
              tags
              class
              _ttl
              createdAt
              updatedAt
              __typename
            }
            bundleId
            bundle {
              id
              txId
              txFee
              status
              uploadCount
              dataItemsCount
              size
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            members {
              nextToken
              __typename
            }
            class
            vaultId
            nodeId
            nodeType
            status
            type
            uploadCount
            size
            verificationId
            verificationCount
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          name
          chunkSize
          numberOfChunks
          resourceUri
          size
          type
          ucm
          udl {
            commercialUses {
              type
              value
              __typename
            }
            currency
            derivations {
              type
              value
              __typename
            }
            dataModelTrainings {
              type
              value
              __typename
            }
            expires
            license
            licenseFee {
              type
              value
              __typename
            }
            paymentAddress
            paymentMode
            unknownUsageRights
            __typename
          }
          status
          external
          nodeType
          tags
          class
          _ttl
          createdAt
          updatedAt
          __typename
        }
        bundleId
        bundle {
          id
          txId
          txFee
          status
          dataItem {
            items {
              id
              owner
              txId
              txFee
              dataItemId
              bundleId
              class
              vaultId
              nodeId
              nodeType
              status
              type
              uploadCount
              size
              verificationId
              verificationCount
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          uploadCount
          dataItemsCount
          size
          signedBy
          signature
          payedBy
          createdAt
          updatedAt
          __typename
        }
        members {
          items {
            id
            address
            email
            vaultId
            vault {
              id
              admin
              data
              description
              name
              owner
              public
              cloud
              blocked
              size
              status
              tags
              termsOfAccess
              createdAt
              updatedAt
              __typename
            }
            memberDetails {
              address
              email
              referralId
              avatar
              profileName
              publicKey
              publicSigningKey
              metadata
              orgId
              orgRole
              _ttl
              createdAt
              updatedAt
              organisationUsersId
              __typename
            }
            data
            expiresAt
            _ttl
            keys {
              encPrivateKey
              encPublicKey
              publicKey
              __typename
            }
            encPublicSigningKey
            message
            owner
            role
            status
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        class
        vaultId
        nodeId
        nodeType
        status
        type
        uploadCount
        size
        verificationId
        verificationCount
        signedBy
        signature
        payedBy
        createdAt
        updatedAt
        __typename
      }
      name
      chunkSize
      numberOfChunks
      resourceUri
      size
      type
      ucm
      udl {
        commercialUses {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        currency
        derivations {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        dataModelTrainings {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        expires
        license
        licenseFee {
          type
          value
          __typename
        }
        paymentAddress
        paymentMode
        unknownUsageRights
        __typename
      }
      status
      external
      nodeType
      tags
      class
      _ttl
      createdAt
      updatedAt
      __typename
    }
    code
    creator
    items
    type
    ucm
    udl {
      commercialUses {
        duration {
          type
          value
          __typename
        }
        fee {
          type
          value
          __typename
        }
        type
        value
        __typename
      }
      currency
      derivations {
        duration {
          type
          value
          __typename
        }
        fee {
          type
          value
          __typename
        }
        type
        value
        __typename
      }
      dataModelTrainings {
        duration {
          type
          value
          __typename
        }
        fee {
          type
          value
          __typename
        }
        type
        value
        __typename
      }
      expires
      license
      licenseFee {
        type
        value
        __typename
      }
      paymentAddress
      paymentMode
      unknownUsageRights
      __typename
    }
    data
    status
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.onUpdateCollection = `subscription OnUpdateCollection(
  $filter: ModelSubscriptionCollectionFilterInput
) {
  onUpdateCollection(filter: $filter) {
    id
    vaultId
    parentId
    name
    description
    owner
    bannerId
    banner {
      id
      nodeId
      owner
      storageTransactionId
      storageTransaction {
        id
        owner
        txId
        txFee
        dataItemId
        fileVersion {
          id
          nodeId
          owner
          storageTransactionId
          storageTransaction {
            id
            owner
            txId
            txFee
            dataItemId
            fileVersion {
              id
              nodeId
              owner
              storageTransactionId
              name
              chunkSize
              numberOfChunks
              resourceUri
              size
              type
              ucm
              status
              external
              nodeType
              tags
              class
              _ttl
              createdAt
              updatedAt
              __typename
            }
            bundleId
            bundle {
              id
              txId
              txFee
              status
              uploadCount
              dataItemsCount
              size
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            members {
              nextToken
              __typename
            }
            class
            vaultId
            nodeId
            nodeType
            status
            type
            uploadCount
            size
            verificationId
            verificationCount
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          name
          chunkSize
          numberOfChunks
          resourceUri
          size
          type
          ucm
          udl {
            commercialUses {
              type
              value
              __typename
            }
            currency
            derivations {
              type
              value
              __typename
            }
            dataModelTrainings {
              type
              value
              __typename
            }
            expires
            license
            licenseFee {
              type
              value
              __typename
            }
            paymentAddress
            paymentMode
            unknownUsageRights
            __typename
          }
          status
          external
          nodeType
          tags
          class
          _ttl
          createdAt
          updatedAt
          __typename
        }
        bundleId
        bundle {
          id
          txId
          txFee
          status
          dataItem {
            items {
              id
              owner
              txId
              txFee
              dataItemId
              bundleId
              class
              vaultId
              nodeId
              nodeType
              status
              type
              uploadCount
              size
              verificationId
              verificationCount
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          uploadCount
          dataItemsCount
          size
          signedBy
          signature
          payedBy
          createdAt
          updatedAt
          __typename
        }
        members {
          items {
            id
            address
            email
            vaultId
            vault {
              id
              admin
              data
              description
              name
              owner
              public
              cloud
              blocked
              size
              status
              tags
              termsOfAccess
              createdAt
              updatedAt
              __typename
            }
            memberDetails {
              address
              email
              referralId
              avatar
              profileName
              publicKey
              publicSigningKey
              metadata
              orgId
              orgRole
              _ttl
              createdAt
              updatedAt
              organisationUsersId
              __typename
            }
            data
            expiresAt
            _ttl
            keys {
              encPrivateKey
              encPublicKey
              publicKey
              __typename
            }
            encPublicSigningKey
            message
            owner
            role
            status
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        class
        vaultId
        nodeId
        nodeType
        status
        type
        uploadCount
        size
        verificationId
        verificationCount
        signedBy
        signature
        payedBy
        createdAt
        updatedAt
        __typename
      }
      name
      chunkSize
      numberOfChunks
      resourceUri
      size
      type
      ucm
      udl {
        commercialUses {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        currency
        derivations {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        dataModelTrainings {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        expires
        license
        licenseFee {
          type
          value
          __typename
        }
        paymentAddress
        paymentMode
        unknownUsageRights
        __typename
      }
      status
      external
      nodeType
      tags
      class
      _ttl
      createdAt
      updatedAt
      __typename
    }
    thumbnailId
    thumbnail {
      id
      nodeId
      owner
      storageTransactionId
      storageTransaction {
        id
        owner
        txId
        txFee
        dataItemId
        fileVersion {
          id
          nodeId
          owner
          storageTransactionId
          storageTransaction {
            id
            owner
            txId
            txFee
            dataItemId
            fileVersion {
              id
              nodeId
              owner
              storageTransactionId
              name
              chunkSize
              numberOfChunks
              resourceUri
              size
              type
              ucm
              status
              external
              nodeType
              tags
              class
              _ttl
              createdAt
              updatedAt
              __typename
            }
            bundleId
            bundle {
              id
              txId
              txFee
              status
              uploadCount
              dataItemsCount
              size
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            members {
              nextToken
              __typename
            }
            class
            vaultId
            nodeId
            nodeType
            status
            type
            uploadCount
            size
            verificationId
            verificationCount
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          name
          chunkSize
          numberOfChunks
          resourceUri
          size
          type
          ucm
          udl {
            commercialUses {
              type
              value
              __typename
            }
            currency
            derivations {
              type
              value
              __typename
            }
            dataModelTrainings {
              type
              value
              __typename
            }
            expires
            license
            licenseFee {
              type
              value
              __typename
            }
            paymentAddress
            paymentMode
            unknownUsageRights
            __typename
          }
          status
          external
          nodeType
          tags
          class
          _ttl
          createdAt
          updatedAt
          __typename
        }
        bundleId
        bundle {
          id
          txId
          txFee
          status
          dataItem {
            items {
              id
              owner
              txId
              txFee
              dataItemId
              bundleId
              class
              vaultId
              nodeId
              nodeType
              status
              type
              uploadCount
              size
              verificationId
              verificationCount
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          uploadCount
          dataItemsCount
          size
          signedBy
          signature
          payedBy
          createdAt
          updatedAt
          __typename
        }
        members {
          items {
            id
            address
            email
            vaultId
            vault {
              id
              admin
              data
              description
              name
              owner
              public
              cloud
              blocked
              size
              status
              tags
              termsOfAccess
              createdAt
              updatedAt
              __typename
            }
            memberDetails {
              address
              email
              referralId
              avatar
              profileName
              publicKey
              publicSigningKey
              metadata
              orgId
              orgRole
              _ttl
              createdAt
              updatedAt
              organisationUsersId
              __typename
            }
            data
            expiresAt
            _ttl
            keys {
              encPrivateKey
              encPublicKey
              publicKey
              __typename
            }
            encPublicSigningKey
            message
            owner
            role
            status
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        class
        vaultId
        nodeId
        nodeType
        status
        type
        uploadCount
        size
        verificationId
        verificationCount
        signedBy
        signature
        payedBy
        createdAt
        updatedAt
        __typename
      }
      name
      chunkSize
      numberOfChunks
      resourceUri
      size
      type
      ucm
      udl {
        commercialUses {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        currency
        derivations {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        dataModelTrainings {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        expires
        license
        licenseFee {
          type
          value
          __typename
        }
        paymentAddress
        paymentMode
        unknownUsageRights
        __typename
      }
      status
      external
      nodeType
      tags
      class
      _ttl
      createdAt
      updatedAt
      __typename
    }
    code
    creator
    items
    type
    ucm
    udl {
      commercialUses {
        duration {
          type
          value
          __typename
        }
        fee {
          type
          value
          __typename
        }
        type
        value
        __typename
      }
      currency
      derivations {
        duration {
          type
          value
          __typename
        }
        fee {
          type
          value
          __typename
        }
        type
        value
        __typename
      }
      dataModelTrainings {
        duration {
          type
          value
          __typename
        }
        fee {
          type
          value
          __typename
        }
        type
        value
        __typename
      }
      expires
      license
      licenseFee {
        type
        value
        __typename
      }
      paymentAddress
      paymentMode
      unknownUsageRights
      __typename
    }
    data
    status
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.onDeleteCollection = `subscription OnDeleteCollection(
  $filter: ModelSubscriptionCollectionFilterInput
) {
  onDeleteCollection(filter: $filter) {
    id
    vaultId
    parentId
    name
    description
    owner
    bannerId
    banner {
      id
      nodeId
      owner
      storageTransactionId
      storageTransaction {
        id
        owner
        txId
        txFee
        dataItemId
        fileVersion {
          id
          nodeId
          owner
          storageTransactionId
          storageTransaction {
            id
            owner
            txId
            txFee
            dataItemId
            fileVersion {
              id
              nodeId
              owner
              storageTransactionId
              name
              chunkSize
              numberOfChunks
              resourceUri
              size
              type
              ucm
              status
              external
              nodeType
              tags
              class
              _ttl
              createdAt
              updatedAt
              __typename
            }
            bundleId
            bundle {
              id
              txId
              txFee
              status
              uploadCount
              dataItemsCount
              size
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            members {
              nextToken
              __typename
            }
            class
            vaultId
            nodeId
            nodeType
            status
            type
            uploadCount
            size
            verificationId
            verificationCount
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          name
          chunkSize
          numberOfChunks
          resourceUri
          size
          type
          ucm
          udl {
            commercialUses {
              type
              value
              __typename
            }
            currency
            derivations {
              type
              value
              __typename
            }
            dataModelTrainings {
              type
              value
              __typename
            }
            expires
            license
            licenseFee {
              type
              value
              __typename
            }
            paymentAddress
            paymentMode
            unknownUsageRights
            __typename
          }
          status
          external
          nodeType
          tags
          class
          _ttl
          createdAt
          updatedAt
          __typename
        }
        bundleId
        bundle {
          id
          txId
          txFee
          status
          dataItem {
            items {
              id
              owner
              txId
              txFee
              dataItemId
              bundleId
              class
              vaultId
              nodeId
              nodeType
              status
              type
              uploadCount
              size
              verificationId
              verificationCount
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          uploadCount
          dataItemsCount
          size
          signedBy
          signature
          payedBy
          createdAt
          updatedAt
          __typename
        }
        members {
          items {
            id
            address
            email
            vaultId
            vault {
              id
              admin
              data
              description
              name
              owner
              public
              cloud
              blocked
              size
              status
              tags
              termsOfAccess
              createdAt
              updatedAt
              __typename
            }
            memberDetails {
              address
              email
              referralId
              avatar
              profileName
              publicKey
              publicSigningKey
              metadata
              orgId
              orgRole
              _ttl
              createdAt
              updatedAt
              organisationUsersId
              __typename
            }
            data
            expiresAt
            _ttl
            keys {
              encPrivateKey
              encPublicKey
              publicKey
              __typename
            }
            encPublicSigningKey
            message
            owner
            role
            status
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        class
        vaultId
        nodeId
        nodeType
        status
        type
        uploadCount
        size
        verificationId
        verificationCount
        signedBy
        signature
        payedBy
        createdAt
        updatedAt
        __typename
      }
      name
      chunkSize
      numberOfChunks
      resourceUri
      size
      type
      ucm
      udl {
        commercialUses {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        currency
        derivations {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        dataModelTrainings {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        expires
        license
        licenseFee {
          type
          value
          __typename
        }
        paymentAddress
        paymentMode
        unknownUsageRights
        __typename
      }
      status
      external
      nodeType
      tags
      class
      _ttl
      createdAt
      updatedAt
      __typename
    }
    thumbnailId
    thumbnail {
      id
      nodeId
      owner
      storageTransactionId
      storageTransaction {
        id
        owner
        txId
        txFee
        dataItemId
        fileVersion {
          id
          nodeId
          owner
          storageTransactionId
          storageTransaction {
            id
            owner
            txId
            txFee
            dataItemId
            fileVersion {
              id
              nodeId
              owner
              storageTransactionId
              name
              chunkSize
              numberOfChunks
              resourceUri
              size
              type
              ucm
              status
              external
              nodeType
              tags
              class
              _ttl
              createdAt
              updatedAt
              __typename
            }
            bundleId
            bundle {
              id
              txId
              txFee
              status
              uploadCount
              dataItemsCount
              size
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            members {
              nextToken
              __typename
            }
            class
            vaultId
            nodeId
            nodeType
            status
            type
            uploadCount
            size
            verificationId
            verificationCount
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          name
          chunkSize
          numberOfChunks
          resourceUri
          size
          type
          ucm
          udl {
            commercialUses {
              type
              value
              __typename
            }
            currency
            derivations {
              type
              value
              __typename
            }
            dataModelTrainings {
              type
              value
              __typename
            }
            expires
            license
            licenseFee {
              type
              value
              __typename
            }
            paymentAddress
            paymentMode
            unknownUsageRights
            __typename
          }
          status
          external
          nodeType
          tags
          class
          _ttl
          createdAt
          updatedAt
          __typename
        }
        bundleId
        bundle {
          id
          txId
          txFee
          status
          dataItem {
            items {
              id
              owner
              txId
              txFee
              dataItemId
              bundleId
              class
              vaultId
              nodeId
              nodeType
              status
              type
              uploadCount
              size
              verificationId
              verificationCount
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          uploadCount
          dataItemsCount
          size
          signedBy
          signature
          payedBy
          createdAt
          updatedAt
          __typename
        }
        members {
          items {
            id
            address
            email
            vaultId
            vault {
              id
              admin
              data
              description
              name
              owner
              public
              cloud
              blocked
              size
              status
              tags
              termsOfAccess
              createdAt
              updatedAt
              __typename
            }
            memberDetails {
              address
              email
              referralId
              avatar
              profileName
              publicKey
              publicSigningKey
              metadata
              orgId
              orgRole
              _ttl
              createdAt
              updatedAt
              organisationUsersId
              __typename
            }
            data
            expiresAt
            _ttl
            keys {
              encPrivateKey
              encPublicKey
              publicKey
              __typename
            }
            encPublicSigningKey
            message
            owner
            role
            status
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        class
        vaultId
        nodeId
        nodeType
        status
        type
        uploadCount
        size
        verificationId
        verificationCount
        signedBy
        signature
        payedBy
        createdAt
        updatedAt
        __typename
      }
      name
      chunkSize
      numberOfChunks
      resourceUri
      size
      type
      ucm
      udl {
        commercialUses {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        currency
        derivations {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        dataModelTrainings {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        expires
        license
        licenseFee {
          type
          value
          __typename
        }
        paymentAddress
        paymentMode
        unknownUsageRights
        __typename
      }
      status
      external
      nodeType
      tags
      class
      _ttl
      createdAt
      updatedAt
      __typename
    }
    code
    creator
    items
    type
    ucm
    udl {
      commercialUses {
        duration {
          type
          value
          __typename
        }
        fee {
          type
          value
          __typename
        }
        type
        value
        __typename
      }
      currency
      derivations {
        duration {
          type
          value
          __typename
        }
        fee {
          type
          value
          __typename
        }
        type
        value
        __typename
      }
      dataModelTrainings {
        duration {
          type
          value
          __typename
        }
        fee {
          type
          value
          __typename
        }
        type
        value
        __typename
      }
      expires
      license
      licenseFee {
        type
        value
        __typename
      }
      paymentAddress
      paymentMode
      unknownUsageRights
      __typename
    }
    data
    status
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.onCreateFileVersion = `subscription OnCreateFileVersion(
  $filter: ModelSubscriptionFileVersionFilterInput
) {
  onCreateFileVersion(filter: $filter) {
    id
    nodeId
    owner
    storageTransactionId
    storageTransaction {
      id
      owner
      txId
      txFee
      dataItemId
      fileVersion {
        id
        nodeId
        owner
        storageTransactionId
        storageTransaction {
          id
          owner
          txId
          txFee
          dataItemId
          fileVersion {
            id
            nodeId
            owner
            storageTransactionId
            storageTransaction {
              id
              owner
              txId
              txFee
              dataItemId
              bundleId
              class
              vaultId
              nodeId
              nodeType
              status
              type
              uploadCount
              size
              verificationId
              verificationCount
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            name
            chunkSize
            numberOfChunks
            resourceUri
            size
            type
            ucm
            udl {
              currency
              expires
              license
              paymentAddress
              paymentMode
              unknownUsageRights
              __typename
            }
            status
            external
            nodeType
            tags
            class
            _ttl
            createdAt
            updatedAt
            __typename
          }
          bundleId
          bundle {
            id
            txId
            txFee
            status
            dataItem {
              nextToken
              __typename
            }
            uploadCount
            dataItemsCount
            size
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          members {
            items {
              id
              address
              email
              vaultId
              data
              expiresAt
              _ttl
              encPublicSigningKey
              message
              owner
              role
              status
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          class
          vaultId
          nodeId
          nodeType
          status
          type
          uploadCount
          size
          verificationId
          verificationCount
          signedBy
          signature
          payedBy
          createdAt
          updatedAt
          __typename
        }
        name
        chunkSize
        numberOfChunks
        resourceUri
        size
        type
        ucm
        udl {
          commercialUses {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          currency
          derivations {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          dataModelTrainings {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          expires
          license
          licenseFee {
            type
            value
            __typename
          }
          paymentAddress
          paymentMode
          unknownUsageRights
          __typename
        }
        status
        external
        nodeType
        tags
        class
        _ttl
        createdAt
        updatedAt
        __typename
      }
      bundleId
      bundle {
        id
        txId
        txFee
        status
        dataItem {
          items {
            id
            owner
            txId
            txFee
            dataItemId
            fileVersion {
              id
              nodeId
              owner
              storageTransactionId
              name
              chunkSize
              numberOfChunks
              resourceUri
              size
              type
              ucm
              status
              external
              nodeType
              tags
              class
              _ttl
              createdAt
              updatedAt
              __typename
            }
            bundleId
            bundle {
              id
              txId
              txFee
              status
              uploadCount
              dataItemsCount
              size
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            members {
              nextToken
              __typename
            }
            class
            vaultId
            nodeId
            nodeType
            status
            type
            uploadCount
            size
            verificationId
            verificationCount
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        uploadCount
        dataItemsCount
        size
        signedBy
        signature
        payedBy
        createdAt
        updatedAt
        __typename
      }
      members {
        items {
          id
          address
          email
          vaultId
          vault {
            id
            membership {
              nextToken
              __typename
            }
            admin
            data
            description
            name
            owner
            public
            cloud
            blocked
            size
            status
            tags
            termsOfAccess
            createdAt
            updatedAt
            __typename
          }
          memberDetails {
            address
            email
            referralId
            avatar
            profileName
            publicKey
            publicSigningKey
            metadata
            orgId
            orgRole
            _ttl
            createdAt
            updatedAt
            organisationUsersId
            __typename
          }
          data
          expiresAt
          _ttl
          keys {
            encPrivateKey
            encPublicKey
            publicKey
            __typename
          }
          encPublicSigningKey
          message
          owner
          role
          status
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      class
      vaultId
      nodeId
      nodeType
      status
      type
      uploadCount
      size
      verificationId
      verificationCount
      signedBy
      signature
      payedBy
      createdAt
      updatedAt
      __typename
    }
    name
    chunkSize
    numberOfChunks
    resourceUri
    size
    type
    ucm
    udl {
      commercialUses {
        duration {
          type
          value
          __typename
        }
        fee {
          type
          value
          __typename
        }
        type
        value
        __typename
      }
      currency
      derivations {
        duration {
          type
          value
          __typename
        }
        fee {
          type
          value
          __typename
        }
        type
        value
        __typename
      }
      dataModelTrainings {
        duration {
          type
          value
          __typename
        }
        fee {
          type
          value
          __typename
        }
        type
        value
        __typename
      }
      expires
      license
      licenseFee {
        type
        value
        __typename
      }
      paymentAddress
      paymentMode
      unknownUsageRights
      __typename
    }
    status
    external
    nodeType
    tags
    class
    _ttl
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.onUpdateFileVersion = `subscription OnUpdateFileVersion(
  $filter: ModelSubscriptionFileVersionFilterInput
) {
  onUpdateFileVersion(filter: $filter) {
    id
    nodeId
    owner
    storageTransactionId
    storageTransaction {
      id
      owner
      txId
      txFee
      dataItemId
      fileVersion {
        id
        nodeId
        owner
        storageTransactionId
        storageTransaction {
          id
          owner
          txId
          txFee
          dataItemId
          fileVersion {
            id
            nodeId
            owner
            storageTransactionId
            storageTransaction {
              id
              owner
              txId
              txFee
              dataItemId
              bundleId
              class
              vaultId
              nodeId
              nodeType
              status
              type
              uploadCount
              size
              verificationId
              verificationCount
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            name
            chunkSize
            numberOfChunks
            resourceUri
            size
            type
            ucm
            udl {
              currency
              expires
              license
              paymentAddress
              paymentMode
              unknownUsageRights
              __typename
            }
            status
            external
            nodeType
            tags
            class
            _ttl
            createdAt
            updatedAt
            __typename
          }
          bundleId
          bundle {
            id
            txId
            txFee
            status
            dataItem {
              nextToken
              __typename
            }
            uploadCount
            dataItemsCount
            size
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          members {
            items {
              id
              address
              email
              vaultId
              data
              expiresAt
              _ttl
              encPublicSigningKey
              message
              owner
              role
              status
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          class
          vaultId
          nodeId
          nodeType
          status
          type
          uploadCount
          size
          verificationId
          verificationCount
          signedBy
          signature
          payedBy
          createdAt
          updatedAt
          __typename
        }
        name
        chunkSize
        numberOfChunks
        resourceUri
        size
        type
        ucm
        udl {
          commercialUses {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          currency
          derivations {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          dataModelTrainings {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          expires
          license
          licenseFee {
            type
            value
            __typename
          }
          paymentAddress
          paymentMode
          unknownUsageRights
          __typename
        }
        status
        external
        nodeType
        tags
        class
        _ttl
        createdAt
        updatedAt
        __typename
      }
      bundleId
      bundle {
        id
        txId
        txFee
        status
        dataItem {
          items {
            id
            owner
            txId
            txFee
            dataItemId
            fileVersion {
              id
              nodeId
              owner
              storageTransactionId
              name
              chunkSize
              numberOfChunks
              resourceUri
              size
              type
              ucm
              status
              external
              nodeType
              tags
              class
              _ttl
              createdAt
              updatedAt
              __typename
            }
            bundleId
            bundle {
              id
              txId
              txFee
              status
              uploadCount
              dataItemsCount
              size
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            members {
              nextToken
              __typename
            }
            class
            vaultId
            nodeId
            nodeType
            status
            type
            uploadCount
            size
            verificationId
            verificationCount
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        uploadCount
        dataItemsCount
        size
        signedBy
        signature
        payedBy
        createdAt
        updatedAt
        __typename
      }
      members {
        items {
          id
          address
          email
          vaultId
          vault {
            id
            membership {
              nextToken
              __typename
            }
            admin
            data
            description
            name
            owner
            public
            cloud
            blocked
            size
            status
            tags
            termsOfAccess
            createdAt
            updatedAt
            __typename
          }
          memberDetails {
            address
            email
            referralId
            avatar
            profileName
            publicKey
            publicSigningKey
            metadata
            orgId
            orgRole
            _ttl
            createdAt
            updatedAt
            organisationUsersId
            __typename
          }
          data
          expiresAt
          _ttl
          keys {
            encPrivateKey
            encPublicKey
            publicKey
            __typename
          }
          encPublicSigningKey
          message
          owner
          role
          status
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      class
      vaultId
      nodeId
      nodeType
      status
      type
      uploadCount
      size
      verificationId
      verificationCount
      signedBy
      signature
      payedBy
      createdAt
      updatedAt
      __typename
    }
    name
    chunkSize
    numberOfChunks
    resourceUri
    size
    type
    ucm
    udl {
      commercialUses {
        duration {
          type
          value
          __typename
        }
        fee {
          type
          value
          __typename
        }
        type
        value
        __typename
      }
      currency
      derivations {
        duration {
          type
          value
          __typename
        }
        fee {
          type
          value
          __typename
        }
        type
        value
        __typename
      }
      dataModelTrainings {
        duration {
          type
          value
          __typename
        }
        fee {
          type
          value
          __typename
        }
        type
        value
        __typename
      }
      expires
      license
      licenseFee {
        type
        value
        __typename
      }
      paymentAddress
      paymentMode
      unknownUsageRights
      __typename
    }
    status
    external
    nodeType
    tags
    class
    _ttl
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.onDeleteFileVersion = `subscription OnDeleteFileVersion(
  $filter: ModelSubscriptionFileVersionFilterInput
) {
  onDeleteFileVersion(filter: $filter) {
    id
    nodeId
    owner
    storageTransactionId
    storageTransaction {
      id
      owner
      txId
      txFee
      dataItemId
      fileVersion {
        id
        nodeId
        owner
        storageTransactionId
        storageTransaction {
          id
          owner
          txId
          txFee
          dataItemId
          fileVersion {
            id
            nodeId
            owner
            storageTransactionId
            storageTransaction {
              id
              owner
              txId
              txFee
              dataItemId
              bundleId
              class
              vaultId
              nodeId
              nodeType
              status
              type
              uploadCount
              size
              verificationId
              verificationCount
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            name
            chunkSize
            numberOfChunks
            resourceUri
            size
            type
            ucm
            udl {
              currency
              expires
              license
              paymentAddress
              paymentMode
              unknownUsageRights
              __typename
            }
            status
            external
            nodeType
            tags
            class
            _ttl
            createdAt
            updatedAt
            __typename
          }
          bundleId
          bundle {
            id
            txId
            txFee
            status
            dataItem {
              nextToken
              __typename
            }
            uploadCount
            dataItemsCount
            size
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          members {
            items {
              id
              address
              email
              vaultId
              data
              expiresAt
              _ttl
              encPublicSigningKey
              message
              owner
              role
              status
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          class
          vaultId
          nodeId
          nodeType
          status
          type
          uploadCount
          size
          verificationId
          verificationCount
          signedBy
          signature
          payedBy
          createdAt
          updatedAt
          __typename
        }
        name
        chunkSize
        numberOfChunks
        resourceUri
        size
        type
        ucm
        udl {
          commercialUses {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          currency
          derivations {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          dataModelTrainings {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          expires
          license
          licenseFee {
            type
            value
            __typename
          }
          paymentAddress
          paymentMode
          unknownUsageRights
          __typename
        }
        status
        external
        nodeType
        tags
        class
        _ttl
        createdAt
        updatedAt
        __typename
      }
      bundleId
      bundle {
        id
        txId
        txFee
        status
        dataItem {
          items {
            id
            owner
            txId
            txFee
            dataItemId
            fileVersion {
              id
              nodeId
              owner
              storageTransactionId
              name
              chunkSize
              numberOfChunks
              resourceUri
              size
              type
              ucm
              status
              external
              nodeType
              tags
              class
              _ttl
              createdAt
              updatedAt
              __typename
            }
            bundleId
            bundle {
              id
              txId
              txFee
              status
              uploadCount
              dataItemsCount
              size
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            members {
              nextToken
              __typename
            }
            class
            vaultId
            nodeId
            nodeType
            status
            type
            uploadCount
            size
            verificationId
            verificationCount
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        uploadCount
        dataItemsCount
        size
        signedBy
        signature
        payedBy
        createdAt
        updatedAt
        __typename
      }
      members {
        items {
          id
          address
          email
          vaultId
          vault {
            id
            membership {
              nextToken
              __typename
            }
            admin
            data
            description
            name
            owner
            public
            cloud
            blocked
            size
            status
            tags
            termsOfAccess
            createdAt
            updatedAt
            __typename
          }
          memberDetails {
            address
            email
            referralId
            avatar
            profileName
            publicKey
            publicSigningKey
            metadata
            orgId
            orgRole
            _ttl
            createdAt
            updatedAt
            organisationUsersId
            __typename
          }
          data
          expiresAt
          _ttl
          keys {
            encPrivateKey
            encPublicKey
            publicKey
            __typename
          }
          encPublicSigningKey
          message
          owner
          role
          status
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      class
      vaultId
      nodeId
      nodeType
      status
      type
      uploadCount
      size
      verificationId
      verificationCount
      signedBy
      signature
      payedBy
      createdAt
      updatedAt
      __typename
    }
    name
    chunkSize
    numberOfChunks
    resourceUri
    size
    type
    ucm
    udl {
      commercialUses {
        duration {
          type
          value
          __typename
        }
        fee {
          type
          value
          __typename
        }
        type
        value
        __typename
      }
      currency
      derivations {
        duration {
          type
          value
          __typename
        }
        fee {
          type
          value
          __typename
        }
        type
        value
        __typename
      }
      dataModelTrainings {
        duration {
          type
          value
          __typename
        }
        fee {
          type
          value
          __typename
        }
        type
        value
        __typename
      }
      expires
      license
      licenseFee {
        type
        value
        __typename
      }
      paymentAddress
      paymentMode
      unknownUsageRights
      __typename
    }
    status
    external
    nodeType
    tags
    class
    _ttl
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.onCreateFolder = `subscription OnCreateFolder($filter: ModelSubscriptionFolderFilterInput) {
  onCreateFolder(filter: $filter) {
    id
    vaultId
    parentId
    data
    name
    owner
    size
    status
    tags
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.onUpdateFolder = `subscription OnUpdateFolder($filter: ModelSubscriptionFolderFilterInput) {
  onUpdateFolder(filter: $filter) {
    id
    vaultId
    parentId
    data
    name
    owner
    size
    status
    tags
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.onDeleteFolder = `subscription OnDeleteFolder($filter: ModelSubscriptionFolderFilterInput) {
  onDeleteFolder(filter: $filter) {
    id
    vaultId
    parentId
    data
    name
    owner
    size
    status
    tags
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.onCreateMemo = `subscription OnCreateMemo($filter: ModelSubscriptionMemoFilterInput) {
  onCreateMemo(filter: $filter) {
    id
    vaultId
    data
    owner
    status
    versions {
      message
      owner
      reactions {
        owner
        reaction
        createdAt
        __typename
      }
      attachments
      createdAt
      __typename
    }
    parentId
    tags
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.onUpdateMemo = `subscription OnUpdateMemo($filter: ModelSubscriptionMemoFilterInput) {
  onUpdateMemo(filter: $filter) {
    id
    vaultId
    data
    owner
    status
    versions {
      message
      owner
      reactions {
        owner
        reaction
        createdAt
        __typename
      }
      attachments
      createdAt
      __typename
    }
    parentId
    tags
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.onDeleteMemo = `subscription OnDeleteMemo($filter: ModelSubscriptionMemoFilterInput) {
  onDeleteMemo(filter: $filter) {
    id
    vaultId
    data
    owner
    status
    versions {
      message
      owner
      reactions {
        owner
        reaction
        createdAt
        __typename
      }
      attachments
      createdAt
      __typename
    }
    parentId
    tags
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.onCreateWhitelist = `subscription OnCreateWhitelist($filter: ModelSubscriptionWhitelistFilterInput) {
  onCreateWhitelist(filter: $filter) {
    id
    vaultId
    owner
    type
    token
    capacity
    access
    members {
      address
      email
      externalAddress
      __typename
    }
    status
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.onUpdateWhitelist = `subscription OnUpdateWhitelist($filter: ModelSubscriptionWhitelistFilterInput) {
  onUpdateWhitelist(filter: $filter) {
    id
    vaultId
    owner
    type
    token
    capacity
    access
    members {
      address
      email
      externalAddress
      __typename
    }
    status
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.onDeleteWhitelist = `subscription OnDeleteWhitelist($filter: ModelSubscriptionWhitelistFilterInput) {
  onDeleteWhitelist(filter: $filter) {
    id
    vaultId
    owner
    type
    token
    capacity
    access
    members {
      address
      email
      externalAddress
      __typename
    }
    status
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.onCreateBundle = `subscription OnCreateBundle($filter: ModelSubscriptionBundleFilterInput) {
  onCreateBundle(filter: $filter) {
    id
    txId
    txFee
    status
    dataItem {
      items {
        id
        owner
        txId
        txFee
        dataItemId
        fileVersion {
          id
          nodeId
          owner
          storageTransactionId
          storageTransaction {
            id
            owner
            txId
            txFee
            dataItemId
            fileVersion {
              id
              nodeId
              owner
              storageTransactionId
              name
              chunkSize
              numberOfChunks
              resourceUri
              size
              type
              ucm
              status
              external
              nodeType
              tags
              class
              _ttl
              createdAt
              updatedAt
              __typename
            }
            bundleId
            bundle {
              id
              txId
              txFee
              status
              uploadCount
              dataItemsCount
              size
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            members {
              nextToken
              __typename
            }
            class
            vaultId
            nodeId
            nodeType
            status
            type
            uploadCount
            size
            verificationId
            verificationCount
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          name
          chunkSize
          numberOfChunks
          resourceUri
          size
          type
          ucm
          udl {
            commercialUses {
              type
              value
              __typename
            }
            currency
            derivations {
              type
              value
              __typename
            }
            dataModelTrainings {
              type
              value
              __typename
            }
            expires
            license
            licenseFee {
              type
              value
              __typename
            }
            paymentAddress
            paymentMode
            unknownUsageRights
            __typename
          }
          status
          external
          nodeType
          tags
          class
          _ttl
          createdAt
          updatedAt
          __typename
        }
        bundleId
        bundle {
          id
          txId
          txFee
          status
          dataItem {
            items {
              id
              owner
              txId
              txFee
              dataItemId
              bundleId
              class
              vaultId
              nodeId
              nodeType
              status
              type
              uploadCount
              size
              verificationId
              verificationCount
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          uploadCount
          dataItemsCount
          size
          signedBy
          signature
          payedBy
          createdAt
          updatedAt
          __typename
        }
        members {
          items {
            id
            address
            email
            vaultId
            vault {
              id
              admin
              data
              description
              name
              owner
              public
              cloud
              blocked
              size
              status
              tags
              termsOfAccess
              createdAt
              updatedAt
              __typename
            }
            memberDetails {
              address
              email
              referralId
              avatar
              profileName
              publicKey
              publicSigningKey
              metadata
              orgId
              orgRole
              _ttl
              createdAt
              updatedAt
              organisationUsersId
              __typename
            }
            data
            expiresAt
            _ttl
            keys {
              encPrivateKey
              encPublicKey
              publicKey
              __typename
            }
            encPublicSigningKey
            message
            owner
            role
            status
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        class
        vaultId
        nodeId
        nodeType
        status
        type
        uploadCount
        size
        verificationId
        verificationCount
        signedBy
        signature
        payedBy
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    uploadCount
    dataItemsCount
    size
    signedBy
    signature
    payedBy
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.onUpdateBundle = `subscription OnUpdateBundle($filter: ModelSubscriptionBundleFilterInput) {
  onUpdateBundle(filter: $filter) {
    id
    txId
    txFee
    status
    dataItem {
      items {
        id
        owner
        txId
        txFee
        dataItemId
        fileVersion {
          id
          nodeId
          owner
          storageTransactionId
          storageTransaction {
            id
            owner
            txId
            txFee
            dataItemId
            fileVersion {
              id
              nodeId
              owner
              storageTransactionId
              name
              chunkSize
              numberOfChunks
              resourceUri
              size
              type
              ucm
              status
              external
              nodeType
              tags
              class
              _ttl
              createdAt
              updatedAt
              __typename
            }
            bundleId
            bundle {
              id
              txId
              txFee
              status
              uploadCount
              dataItemsCount
              size
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            members {
              nextToken
              __typename
            }
            class
            vaultId
            nodeId
            nodeType
            status
            type
            uploadCount
            size
            verificationId
            verificationCount
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          name
          chunkSize
          numberOfChunks
          resourceUri
          size
          type
          ucm
          udl {
            commercialUses {
              type
              value
              __typename
            }
            currency
            derivations {
              type
              value
              __typename
            }
            dataModelTrainings {
              type
              value
              __typename
            }
            expires
            license
            licenseFee {
              type
              value
              __typename
            }
            paymentAddress
            paymentMode
            unknownUsageRights
            __typename
          }
          status
          external
          nodeType
          tags
          class
          _ttl
          createdAt
          updatedAt
          __typename
        }
        bundleId
        bundle {
          id
          txId
          txFee
          status
          dataItem {
            items {
              id
              owner
              txId
              txFee
              dataItemId
              bundleId
              class
              vaultId
              nodeId
              nodeType
              status
              type
              uploadCount
              size
              verificationId
              verificationCount
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          uploadCount
          dataItemsCount
          size
          signedBy
          signature
          payedBy
          createdAt
          updatedAt
          __typename
        }
        members {
          items {
            id
            address
            email
            vaultId
            vault {
              id
              admin
              data
              description
              name
              owner
              public
              cloud
              blocked
              size
              status
              tags
              termsOfAccess
              createdAt
              updatedAt
              __typename
            }
            memberDetails {
              address
              email
              referralId
              avatar
              profileName
              publicKey
              publicSigningKey
              metadata
              orgId
              orgRole
              _ttl
              createdAt
              updatedAt
              organisationUsersId
              __typename
            }
            data
            expiresAt
            _ttl
            keys {
              encPrivateKey
              encPublicKey
              publicKey
              __typename
            }
            encPublicSigningKey
            message
            owner
            role
            status
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        class
        vaultId
        nodeId
        nodeType
        status
        type
        uploadCount
        size
        verificationId
        verificationCount
        signedBy
        signature
        payedBy
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    uploadCount
    dataItemsCount
    size
    signedBy
    signature
    payedBy
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.onDeleteBundle = `subscription OnDeleteBundle($filter: ModelSubscriptionBundleFilterInput) {
  onDeleteBundle(filter: $filter) {
    id
    txId
    txFee
    status
    dataItem {
      items {
        id
        owner
        txId
        txFee
        dataItemId
        fileVersion {
          id
          nodeId
          owner
          storageTransactionId
          storageTransaction {
            id
            owner
            txId
            txFee
            dataItemId
            fileVersion {
              id
              nodeId
              owner
              storageTransactionId
              name
              chunkSize
              numberOfChunks
              resourceUri
              size
              type
              ucm
              status
              external
              nodeType
              tags
              class
              _ttl
              createdAt
              updatedAt
              __typename
            }
            bundleId
            bundle {
              id
              txId
              txFee
              status
              uploadCount
              dataItemsCount
              size
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            members {
              nextToken
              __typename
            }
            class
            vaultId
            nodeId
            nodeType
            status
            type
            uploadCount
            size
            verificationId
            verificationCount
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          name
          chunkSize
          numberOfChunks
          resourceUri
          size
          type
          ucm
          udl {
            commercialUses {
              type
              value
              __typename
            }
            currency
            derivations {
              type
              value
              __typename
            }
            dataModelTrainings {
              type
              value
              __typename
            }
            expires
            license
            licenseFee {
              type
              value
              __typename
            }
            paymentAddress
            paymentMode
            unknownUsageRights
            __typename
          }
          status
          external
          nodeType
          tags
          class
          _ttl
          createdAt
          updatedAt
          __typename
        }
        bundleId
        bundle {
          id
          txId
          txFee
          status
          dataItem {
            items {
              id
              owner
              txId
              txFee
              dataItemId
              bundleId
              class
              vaultId
              nodeId
              nodeType
              status
              type
              uploadCount
              size
              verificationId
              verificationCount
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          uploadCount
          dataItemsCount
          size
          signedBy
          signature
          payedBy
          createdAt
          updatedAt
          __typename
        }
        members {
          items {
            id
            address
            email
            vaultId
            vault {
              id
              admin
              data
              description
              name
              owner
              public
              cloud
              blocked
              size
              status
              tags
              termsOfAccess
              createdAt
              updatedAt
              __typename
            }
            memberDetails {
              address
              email
              referralId
              avatar
              profileName
              publicKey
              publicSigningKey
              metadata
              orgId
              orgRole
              _ttl
              createdAt
              updatedAt
              organisationUsersId
              __typename
            }
            data
            expiresAt
            _ttl
            keys {
              encPrivateKey
              encPublicKey
              publicKey
              __typename
            }
            encPublicSigningKey
            message
            owner
            role
            status
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        class
        vaultId
        nodeId
        nodeType
        status
        type
        uploadCount
        size
        verificationId
        verificationCount
        signedBy
        signature
        payedBy
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    uploadCount
    dataItemsCount
    size
    signedBy
    signature
    payedBy
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.onCreateStorageTransaction = `subscription OnCreateStorageTransaction(
  $filter: ModelSubscriptionStorageTransactionFilterInput
) {
  onCreateStorageTransaction(filter: $filter) {
    id
    owner
    txId
    txFee
    dataItemId
    fileVersion {
      id
      nodeId
      owner
      storageTransactionId
      storageTransaction {
        id
        owner
        txId
        txFee
        dataItemId
        fileVersion {
          id
          nodeId
          owner
          storageTransactionId
          storageTransaction {
            id
            owner
            txId
            txFee
            dataItemId
            fileVersion {
              id
              nodeId
              owner
              storageTransactionId
              name
              chunkSize
              numberOfChunks
              resourceUri
              size
              type
              ucm
              status
              external
              nodeType
              tags
              class
              _ttl
              createdAt
              updatedAt
              __typename
            }
            bundleId
            bundle {
              id
              txId
              txFee
              status
              uploadCount
              dataItemsCount
              size
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            members {
              nextToken
              __typename
            }
            class
            vaultId
            nodeId
            nodeType
            status
            type
            uploadCount
            size
            verificationId
            verificationCount
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          name
          chunkSize
          numberOfChunks
          resourceUri
          size
          type
          ucm
          udl {
            commercialUses {
              type
              value
              __typename
            }
            currency
            derivations {
              type
              value
              __typename
            }
            dataModelTrainings {
              type
              value
              __typename
            }
            expires
            license
            licenseFee {
              type
              value
              __typename
            }
            paymentAddress
            paymentMode
            unknownUsageRights
            __typename
          }
          status
          external
          nodeType
          tags
          class
          _ttl
          createdAt
          updatedAt
          __typename
        }
        bundleId
        bundle {
          id
          txId
          txFee
          status
          dataItem {
            items {
              id
              owner
              txId
              txFee
              dataItemId
              bundleId
              class
              vaultId
              nodeId
              nodeType
              status
              type
              uploadCount
              size
              verificationId
              verificationCount
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          uploadCount
          dataItemsCount
          size
          signedBy
          signature
          payedBy
          createdAt
          updatedAt
          __typename
        }
        members {
          items {
            id
            address
            email
            vaultId
            vault {
              id
              admin
              data
              description
              name
              owner
              public
              cloud
              blocked
              size
              status
              tags
              termsOfAccess
              createdAt
              updatedAt
              __typename
            }
            memberDetails {
              address
              email
              referralId
              avatar
              profileName
              publicKey
              publicSigningKey
              metadata
              orgId
              orgRole
              _ttl
              createdAt
              updatedAt
              organisationUsersId
              __typename
            }
            data
            expiresAt
            _ttl
            keys {
              encPrivateKey
              encPublicKey
              publicKey
              __typename
            }
            encPublicSigningKey
            message
            owner
            role
            status
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        class
        vaultId
        nodeId
        nodeType
        status
        type
        uploadCount
        size
        verificationId
        verificationCount
        signedBy
        signature
        payedBy
        createdAt
        updatedAt
        __typename
      }
      name
      chunkSize
      numberOfChunks
      resourceUri
      size
      type
      ucm
      udl {
        commercialUses {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        currency
        derivations {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        dataModelTrainings {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        expires
        license
        licenseFee {
          type
          value
          __typename
        }
        paymentAddress
        paymentMode
        unknownUsageRights
        __typename
      }
      status
      external
      nodeType
      tags
      class
      _ttl
      createdAt
      updatedAt
      __typename
    }
    bundleId
    bundle {
      id
      txId
      txFee
      status
      dataItem {
        items {
          id
          owner
          txId
          txFee
          dataItemId
          fileVersion {
            id
            nodeId
            owner
            storageTransactionId
            storageTransaction {
              id
              owner
              txId
              txFee
              dataItemId
              bundleId
              class
              vaultId
              nodeId
              nodeType
              status
              type
              uploadCount
              size
              verificationId
              verificationCount
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            name
            chunkSize
            numberOfChunks
            resourceUri
            size
            type
            ucm
            udl {
              currency
              expires
              license
              paymentAddress
              paymentMode
              unknownUsageRights
              __typename
            }
            status
            external
            nodeType
            tags
            class
            _ttl
            createdAt
            updatedAt
            __typename
          }
          bundleId
          bundle {
            id
            txId
            txFee
            status
            dataItem {
              nextToken
              __typename
            }
            uploadCount
            dataItemsCount
            size
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          members {
            items {
              id
              address
              email
              vaultId
              data
              expiresAt
              _ttl
              encPublicSigningKey
              message
              owner
              role
              status
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          class
          vaultId
          nodeId
          nodeType
          status
          type
          uploadCount
          size
          verificationId
          verificationCount
          signedBy
          signature
          payedBy
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      uploadCount
      dataItemsCount
      size
      signedBy
      signature
      payedBy
      createdAt
      updatedAt
      __typename
    }
    members {
      items {
        id
        address
        email
        vaultId
        vault {
          id
          membership {
            items {
              id
              address
              email
              vaultId
              data
              expiresAt
              _ttl
              encPublicSigningKey
              message
              owner
              role
              status
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          admin
          data
          description
          name
          owner
          public
          cloud
          blocked
          size
          status
          tags
          termsOfAccess
          createdAt
          updatedAt
          __typename
        }
        memberDetails {
          address
          email
          referralId
          avatar
          profileName
          publicKey
          publicSigningKey
          metadata
          orgId
          orgRole
          _ttl
          createdAt
          updatedAt
          organisationUsersId
          __typename
        }
        data
        expiresAt
        _ttl
        keys {
          encPrivateKey
          encPublicKey
          publicKey
          __typename
        }
        encPublicSigningKey
        message
        owner
        role
        status
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    class
    vaultId
    nodeId
    nodeType
    status
    type
    uploadCount
    size
    verificationId
    verificationCount
    signedBy
    signature
    payedBy
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.onUpdateStorageTransaction = `subscription OnUpdateStorageTransaction(
  $filter: ModelSubscriptionStorageTransactionFilterInput
) {
  onUpdateStorageTransaction(filter: $filter) {
    id
    owner
    txId
    txFee
    dataItemId
    fileVersion {
      id
      nodeId
      owner
      storageTransactionId
      storageTransaction {
        id
        owner
        txId
        txFee
        dataItemId
        fileVersion {
          id
          nodeId
          owner
          storageTransactionId
          storageTransaction {
            id
            owner
            txId
            txFee
            dataItemId
            fileVersion {
              id
              nodeId
              owner
              storageTransactionId
              name
              chunkSize
              numberOfChunks
              resourceUri
              size
              type
              ucm
              status
              external
              nodeType
              tags
              class
              _ttl
              createdAt
              updatedAt
              __typename
            }
            bundleId
            bundle {
              id
              txId
              txFee
              status
              uploadCount
              dataItemsCount
              size
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            members {
              nextToken
              __typename
            }
            class
            vaultId
            nodeId
            nodeType
            status
            type
            uploadCount
            size
            verificationId
            verificationCount
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          name
          chunkSize
          numberOfChunks
          resourceUri
          size
          type
          ucm
          udl {
            commercialUses {
              type
              value
              __typename
            }
            currency
            derivations {
              type
              value
              __typename
            }
            dataModelTrainings {
              type
              value
              __typename
            }
            expires
            license
            licenseFee {
              type
              value
              __typename
            }
            paymentAddress
            paymentMode
            unknownUsageRights
            __typename
          }
          status
          external
          nodeType
          tags
          class
          _ttl
          createdAt
          updatedAt
          __typename
        }
        bundleId
        bundle {
          id
          txId
          txFee
          status
          dataItem {
            items {
              id
              owner
              txId
              txFee
              dataItemId
              bundleId
              class
              vaultId
              nodeId
              nodeType
              status
              type
              uploadCount
              size
              verificationId
              verificationCount
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          uploadCount
          dataItemsCount
          size
          signedBy
          signature
          payedBy
          createdAt
          updatedAt
          __typename
        }
        members {
          items {
            id
            address
            email
            vaultId
            vault {
              id
              admin
              data
              description
              name
              owner
              public
              cloud
              blocked
              size
              status
              tags
              termsOfAccess
              createdAt
              updatedAt
              __typename
            }
            memberDetails {
              address
              email
              referralId
              avatar
              profileName
              publicKey
              publicSigningKey
              metadata
              orgId
              orgRole
              _ttl
              createdAt
              updatedAt
              organisationUsersId
              __typename
            }
            data
            expiresAt
            _ttl
            keys {
              encPrivateKey
              encPublicKey
              publicKey
              __typename
            }
            encPublicSigningKey
            message
            owner
            role
            status
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        class
        vaultId
        nodeId
        nodeType
        status
        type
        uploadCount
        size
        verificationId
        verificationCount
        signedBy
        signature
        payedBy
        createdAt
        updatedAt
        __typename
      }
      name
      chunkSize
      numberOfChunks
      resourceUri
      size
      type
      ucm
      udl {
        commercialUses {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        currency
        derivations {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        dataModelTrainings {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        expires
        license
        licenseFee {
          type
          value
          __typename
        }
        paymentAddress
        paymentMode
        unknownUsageRights
        __typename
      }
      status
      external
      nodeType
      tags
      class
      _ttl
      createdAt
      updatedAt
      __typename
    }
    bundleId
    bundle {
      id
      txId
      txFee
      status
      dataItem {
        items {
          id
          owner
          txId
          txFee
          dataItemId
          fileVersion {
            id
            nodeId
            owner
            storageTransactionId
            storageTransaction {
              id
              owner
              txId
              txFee
              dataItemId
              bundleId
              class
              vaultId
              nodeId
              nodeType
              status
              type
              uploadCount
              size
              verificationId
              verificationCount
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            name
            chunkSize
            numberOfChunks
            resourceUri
            size
            type
            ucm
            udl {
              currency
              expires
              license
              paymentAddress
              paymentMode
              unknownUsageRights
              __typename
            }
            status
            external
            nodeType
            tags
            class
            _ttl
            createdAt
            updatedAt
            __typename
          }
          bundleId
          bundle {
            id
            txId
            txFee
            status
            dataItem {
              nextToken
              __typename
            }
            uploadCount
            dataItemsCount
            size
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          members {
            items {
              id
              address
              email
              vaultId
              data
              expiresAt
              _ttl
              encPublicSigningKey
              message
              owner
              role
              status
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          class
          vaultId
          nodeId
          nodeType
          status
          type
          uploadCount
          size
          verificationId
          verificationCount
          signedBy
          signature
          payedBy
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      uploadCount
      dataItemsCount
      size
      signedBy
      signature
      payedBy
      createdAt
      updatedAt
      __typename
    }
    members {
      items {
        id
        address
        email
        vaultId
        vault {
          id
          membership {
            items {
              id
              address
              email
              vaultId
              data
              expiresAt
              _ttl
              encPublicSigningKey
              message
              owner
              role
              status
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          admin
          data
          description
          name
          owner
          public
          cloud
          blocked
          size
          status
          tags
          termsOfAccess
          createdAt
          updatedAt
          __typename
        }
        memberDetails {
          address
          email
          referralId
          avatar
          profileName
          publicKey
          publicSigningKey
          metadata
          orgId
          orgRole
          _ttl
          createdAt
          updatedAt
          organisationUsersId
          __typename
        }
        data
        expiresAt
        _ttl
        keys {
          encPrivateKey
          encPublicKey
          publicKey
          __typename
        }
        encPublicSigningKey
        message
        owner
        role
        status
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    class
    vaultId
    nodeId
    nodeType
    status
    type
    uploadCount
    size
    verificationId
    verificationCount
    signedBy
    signature
    payedBy
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.onDeleteStorageTransaction = `subscription OnDeleteStorageTransaction(
  $filter: ModelSubscriptionStorageTransactionFilterInput
) {
  onDeleteStorageTransaction(filter: $filter) {
    id
    owner
    txId
    txFee
    dataItemId
    fileVersion {
      id
      nodeId
      owner
      storageTransactionId
      storageTransaction {
        id
        owner
        txId
        txFee
        dataItemId
        fileVersion {
          id
          nodeId
          owner
          storageTransactionId
          storageTransaction {
            id
            owner
            txId
            txFee
            dataItemId
            fileVersion {
              id
              nodeId
              owner
              storageTransactionId
              name
              chunkSize
              numberOfChunks
              resourceUri
              size
              type
              ucm
              status
              external
              nodeType
              tags
              class
              _ttl
              createdAt
              updatedAt
              __typename
            }
            bundleId
            bundle {
              id
              txId
              txFee
              status
              uploadCount
              dataItemsCount
              size
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            members {
              nextToken
              __typename
            }
            class
            vaultId
            nodeId
            nodeType
            status
            type
            uploadCount
            size
            verificationId
            verificationCount
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          name
          chunkSize
          numberOfChunks
          resourceUri
          size
          type
          ucm
          udl {
            commercialUses {
              type
              value
              __typename
            }
            currency
            derivations {
              type
              value
              __typename
            }
            dataModelTrainings {
              type
              value
              __typename
            }
            expires
            license
            licenseFee {
              type
              value
              __typename
            }
            paymentAddress
            paymentMode
            unknownUsageRights
            __typename
          }
          status
          external
          nodeType
          tags
          class
          _ttl
          createdAt
          updatedAt
          __typename
        }
        bundleId
        bundle {
          id
          txId
          txFee
          status
          dataItem {
            items {
              id
              owner
              txId
              txFee
              dataItemId
              bundleId
              class
              vaultId
              nodeId
              nodeType
              status
              type
              uploadCount
              size
              verificationId
              verificationCount
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          uploadCount
          dataItemsCount
          size
          signedBy
          signature
          payedBy
          createdAt
          updatedAt
          __typename
        }
        members {
          items {
            id
            address
            email
            vaultId
            vault {
              id
              admin
              data
              description
              name
              owner
              public
              cloud
              blocked
              size
              status
              tags
              termsOfAccess
              createdAt
              updatedAt
              __typename
            }
            memberDetails {
              address
              email
              referralId
              avatar
              profileName
              publicKey
              publicSigningKey
              metadata
              orgId
              orgRole
              _ttl
              createdAt
              updatedAt
              organisationUsersId
              __typename
            }
            data
            expiresAt
            _ttl
            keys {
              encPrivateKey
              encPublicKey
              publicKey
              __typename
            }
            encPublicSigningKey
            message
            owner
            role
            status
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        class
        vaultId
        nodeId
        nodeType
        status
        type
        uploadCount
        size
        verificationId
        verificationCount
        signedBy
        signature
        payedBy
        createdAt
        updatedAt
        __typename
      }
      name
      chunkSize
      numberOfChunks
      resourceUri
      size
      type
      ucm
      udl {
        commercialUses {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        currency
        derivations {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        dataModelTrainings {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        expires
        license
        licenseFee {
          type
          value
          __typename
        }
        paymentAddress
        paymentMode
        unknownUsageRights
        __typename
      }
      status
      external
      nodeType
      tags
      class
      _ttl
      createdAt
      updatedAt
      __typename
    }
    bundleId
    bundle {
      id
      txId
      txFee
      status
      dataItem {
        items {
          id
          owner
          txId
          txFee
          dataItemId
          fileVersion {
            id
            nodeId
            owner
            storageTransactionId
            storageTransaction {
              id
              owner
              txId
              txFee
              dataItemId
              bundleId
              class
              vaultId
              nodeId
              nodeType
              status
              type
              uploadCount
              size
              verificationId
              verificationCount
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            name
            chunkSize
            numberOfChunks
            resourceUri
            size
            type
            ucm
            udl {
              currency
              expires
              license
              paymentAddress
              paymentMode
              unknownUsageRights
              __typename
            }
            status
            external
            nodeType
            tags
            class
            _ttl
            createdAt
            updatedAt
            __typename
          }
          bundleId
          bundle {
            id
            txId
            txFee
            status
            dataItem {
              nextToken
              __typename
            }
            uploadCount
            dataItemsCount
            size
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          members {
            items {
              id
              address
              email
              vaultId
              data
              expiresAt
              _ttl
              encPublicSigningKey
              message
              owner
              role
              status
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          class
          vaultId
          nodeId
          nodeType
          status
          type
          uploadCount
          size
          verificationId
          verificationCount
          signedBy
          signature
          payedBy
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      uploadCount
      dataItemsCount
      size
      signedBy
      signature
      payedBy
      createdAt
      updatedAt
      __typename
    }
    members {
      items {
        id
        address
        email
        vaultId
        vault {
          id
          membership {
            items {
              id
              address
              email
              vaultId
              data
              expiresAt
              _ttl
              encPublicSigningKey
              message
              owner
              role
              status
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          admin
          data
          description
          name
          owner
          public
          cloud
          blocked
          size
          status
          tags
          termsOfAccess
          createdAt
          updatedAt
          __typename
        }
        memberDetails {
          address
          email
          referralId
          avatar
          profileName
          publicKey
          publicSigningKey
          metadata
          orgId
          orgRole
          _ttl
          createdAt
          updatedAt
          organisationUsersId
          __typename
        }
        data
        expiresAt
        _ttl
        keys {
          encPrivateKey
          encPublicKey
          publicKey
          __typename
        }
        encPublicSigningKey
        message
        owner
        role
        status
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    class
    vaultId
    nodeId
    nodeType
    status
    type
    uploadCount
    size
    verificationId
    verificationCount
    signedBy
    signature
    payedBy
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.onCreateTransaction = `subscription OnCreateTransaction(
  $filter: ModelSubscriptionTransactionFilterInput
) {
  onCreateTransaction(filter: $filter) {
    id
    txId
    function
    owner
    vaultId
    actionRef
    groupRef
    objectId
    objectType
    data
    input
    referrer
    status
    tags
    cloud
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.onUpdateTransaction = `subscription OnUpdateTransaction(
  $filter: ModelSubscriptionTransactionFilterInput
) {
  onUpdateTransaction(filter: $filter) {
    id
    txId
    function
    owner
    vaultId
    actionRef
    groupRef
    objectId
    objectType
    data
    input
    referrer
    status
    tags
    cloud
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.onDeleteTransaction = `subscription OnDeleteTransaction(
  $filter: ModelSubscriptionTransactionFilterInput
) {
  onDeleteTransaction(filter: $filter) {
    id
    txId
    function
    owner
    vaultId
    actionRef
    groupRef
    objectId
    objectType
    data
    input
    referrer
    status
    tags
    cloud
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.onCreateTransactionLog = `subscription OnCreateTransactionLog(
  $filter: ModelSubscriptionTransactionLogFilterInput
) {
  onCreateTransactionLog(filter: $filter) {
    id
    owner
    actionRef
    admin
    content
    vaultId
    groupRef
    hash
    objectId
    objectType
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.onUpdateTransactionLog = `subscription OnUpdateTransactionLog(
  $filter: ModelSubscriptionTransactionLogFilterInput
) {
  onUpdateTransactionLog(filter: $filter) {
    id
    owner
    actionRef
    admin
    content
    vaultId
    groupRef
    hash
    objectId
    objectType
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.onDeleteTransactionLog = `subscription OnDeleteTransactionLog(
  $filter: ModelSubscriptionTransactionLogFilterInput
) {
  onDeleteTransactionLog(filter: $filter) {
    id
    owner
    actionRef
    admin
    content
    vaultId
    groupRef
    hash
    objectId
    objectType
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.onCreateNotification = `subscription OnCreateNotification(
  $filter: ModelSubscriptionNotificationFilterInput
) {
  onCreateNotification(filter: $filter) {
    id
    fromAddress
    from {
      address
      email
      referralId
      avatar
      profileName
      publicKey
      publicSigningKey
      metadata
      orgId
      orgRole
      _ttl
      createdAt
      updatedAt
      organisationUsersId
      __typename
    }
    toAddress
    to {
      address
      email
      referralId
      avatar
      profileName
      publicKey
      publicSigningKey
      metadata
      orgId
      orgRole
      _ttl
      createdAt
      updatedAt
      organisationUsersId
      __typename
    }
    toMemberId
    toMember {
      id
      address
      email
      vaultId
      vault {
        id
        membership {
          items {
            id
            address
            email
            vaultId
            vault {
              id
              admin
              data
              description
              name
              owner
              public
              cloud
              blocked
              size
              status
              tags
              termsOfAccess
              createdAt
              updatedAt
              __typename
            }
            memberDetails {
              address
              email
              referralId
              avatar
              profileName
              publicKey
              publicSigningKey
              metadata
              orgId
              orgRole
              _ttl
              createdAt
              updatedAt
              organisationUsersId
              __typename
            }
            data
            expiresAt
            _ttl
            keys {
              encPrivateKey
              encPublicKey
              publicKey
              __typename
            }
            encPublicSigningKey
            message
            owner
            role
            status
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        admin
        data
        description
        name
        owner
        public
        cloud
        blocked
        size
        status
        tags
        termsOfAccess
        createdAt
        updatedAt
        __typename
      }
      memberDetails {
        address
        email
        referralId
        avatar
        profileName
        publicKey
        publicSigningKey
        metadata
        orgId
        orgRole
        _ttl
        createdAt
        updatedAt
        organisationUsersId
        __typename
      }
      data
      expiresAt
      _ttl
      keys {
        encPrivateKey
        encPublicKey
        publicKey
        __typename
      }
      encPublicSigningKey
      message
      owner
      role
      status
      createdAt
      updatedAt
      __typename
    }
    toEmail
    vaultId
    vault {
      id
      membership {
        items {
          id
          address
          email
          vaultId
          vault {
            id
            membership {
              nextToken
              __typename
            }
            admin
            data
            description
            name
            owner
            public
            cloud
            blocked
            size
            status
            tags
            termsOfAccess
            createdAt
            updatedAt
            __typename
          }
          memberDetails {
            address
            email
            referralId
            avatar
            profileName
            publicKey
            publicSigningKey
            metadata
            orgId
            orgRole
            _ttl
            createdAt
            updatedAt
            organisationUsersId
            __typename
          }
          data
          expiresAt
          _ttl
          keys {
            encPrivateKey
            encPublicKey
            publicKey
            __typename
          }
          encPublicSigningKey
          message
          owner
          role
          status
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      admin
      data
      description
      name
      owner
      public
      cloud
      blocked
      size
      status
      tags
      termsOfAccess
      createdAt
      updatedAt
      __typename
    }
    objectId
    objectType
    objectName
    event
    channels
    content
    status
    priority
    activity
    admin
    count
    host
    _ttl
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.onUpdateNotification = `subscription OnUpdateNotification(
  $filter: ModelSubscriptionNotificationFilterInput
) {
  onUpdateNotification(filter: $filter) {
    id
    fromAddress
    from {
      address
      email
      referralId
      avatar
      profileName
      publicKey
      publicSigningKey
      metadata
      orgId
      orgRole
      _ttl
      createdAt
      updatedAt
      organisationUsersId
      __typename
    }
    toAddress
    to {
      address
      email
      referralId
      avatar
      profileName
      publicKey
      publicSigningKey
      metadata
      orgId
      orgRole
      _ttl
      createdAt
      updatedAt
      organisationUsersId
      __typename
    }
    toMemberId
    toMember {
      id
      address
      email
      vaultId
      vault {
        id
        membership {
          items {
            id
            address
            email
            vaultId
            vault {
              id
              admin
              data
              description
              name
              owner
              public
              cloud
              blocked
              size
              status
              tags
              termsOfAccess
              createdAt
              updatedAt
              __typename
            }
            memberDetails {
              address
              email
              referralId
              avatar
              profileName
              publicKey
              publicSigningKey
              metadata
              orgId
              orgRole
              _ttl
              createdAt
              updatedAt
              organisationUsersId
              __typename
            }
            data
            expiresAt
            _ttl
            keys {
              encPrivateKey
              encPublicKey
              publicKey
              __typename
            }
            encPublicSigningKey
            message
            owner
            role
            status
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        admin
        data
        description
        name
        owner
        public
        cloud
        blocked
        size
        status
        tags
        termsOfAccess
        createdAt
        updatedAt
        __typename
      }
      memberDetails {
        address
        email
        referralId
        avatar
        profileName
        publicKey
        publicSigningKey
        metadata
        orgId
        orgRole
        _ttl
        createdAt
        updatedAt
        organisationUsersId
        __typename
      }
      data
      expiresAt
      _ttl
      keys {
        encPrivateKey
        encPublicKey
        publicKey
        __typename
      }
      encPublicSigningKey
      message
      owner
      role
      status
      createdAt
      updatedAt
      __typename
    }
    toEmail
    vaultId
    vault {
      id
      membership {
        items {
          id
          address
          email
          vaultId
          vault {
            id
            membership {
              nextToken
              __typename
            }
            admin
            data
            description
            name
            owner
            public
            cloud
            blocked
            size
            status
            tags
            termsOfAccess
            createdAt
            updatedAt
            __typename
          }
          memberDetails {
            address
            email
            referralId
            avatar
            profileName
            publicKey
            publicSigningKey
            metadata
            orgId
            orgRole
            _ttl
            createdAt
            updatedAt
            organisationUsersId
            __typename
          }
          data
          expiresAt
          _ttl
          keys {
            encPrivateKey
            encPublicKey
            publicKey
            __typename
          }
          encPublicSigningKey
          message
          owner
          role
          status
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      admin
      data
      description
      name
      owner
      public
      cloud
      blocked
      size
      status
      tags
      termsOfAccess
      createdAt
      updatedAt
      __typename
    }
    objectId
    objectType
    objectName
    event
    channels
    content
    status
    priority
    activity
    admin
    count
    host
    _ttl
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.onDeleteNotification = `subscription OnDeleteNotification(
  $filter: ModelSubscriptionNotificationFilterInput
) {
  onDeleteNotification(filter: $filter) {
    id
    fromAddress
    from {
      address
      email
      referralId
      avatar
      profileName
      publicKey
      publicSigningKey
      metadata
      orgId
      orgRole
      _ttl
      createdAt
      updatedAt
      organisationUsersId
      __typename
    }
    toAddress
    to {
      address
      email
      referralId
      avatar
      profileName
      publicKey
      publicSigningKey
      metadata
      orgId
      orgRole
      _ttl
      createdAt
      updatedAt
      organisationUsersId
      __typename
    }
    toMemberId
    toMember {
      id
      address
      email
      vaultId
      vault {
        id
        membership {
          items {
            id
            address
            email
            vaultId
            vault {
              id
              admin
              data
              description
              name
              owner
              public
              cloud
              blocked
              size
              status
              tags
              termsOfAccess
              createdAt
              updatedAt
              __typename
            }
            memberDetails {
              address
              email
              referralId
              avatar
              profileName
              publicKey
              publicSigningKey
              metadata
              orgId
              orgRole
              _ttl
              createdAt
              updatedAt
              organisationUsersId
              __typename
            }
            data
            expiresAt
            _ttl
            keys {
              encPrivateKey
              encPublicKey
              publicKey
              __typename
            }
            encPublicSigningKey
            message
            owner
            role
            status
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        admin
        data
        description
        name
        owner
        public
        cloud
        blocked
        size
        status
        tags
        termsOfAccess
        createdAt
        updatedAt
        __typename
      }
      memberDetails {
        address
        email
        referralId
        avatar
        profileName
        publicKey
        publicSigningKey
        metadata
        orgId
        orgRole
        _ttl
        createdAt
        updatedAt
        organisationUsersId
        __typename
      }
      data
      expiresAt
      _ttl
      keys {
        encPrivateKey
        encPublicKey
        publicKey
        __typename
      }
      encPublicSigningKey
      message
      owner
      role
      status
      createdAt
      updatedAt
      __typename
    }
    toEmail
    vaultId
    vault {
      id
      membership {
        items {
          id
          address
          email
          vaultId
          vault {
            id
            membership {
              nextToken
              __typename
            }
            admin
            data
            description
            name
            owner
            public
            cloud
            blocked
            size
            status
            tags
            termsOfAccess
            createdAt
            updatedAt
            __typename
          }
          memberDetails {
            address
            email
            referralId
            avatar
            profileName
            publicKey
            publicSigningKey
            metadata
            orgId
            orgRole
            _ttl
            createdAt
            updatedAt
            organisationUsersId
            __typename
          }
          data
          expiresAt
          _ttl
          keys {
            encPrivateKey
            encPublicKey
            publicKey
            __typename
          }
          encPublicSigningKey
          message
          owner
          role
          status
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      admin
      data
      description
      name
      owner
      public
      cloud
      blocked
      size
      status
      tags
      termsOfAccess
      createdAt
      updatedAt
      __typename
    }
    objectId
    objectType
    objectName
    event
    channels
    content
    status
    priority
    activity
    admin
    count
    host
    _ttl
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.onCreateUser = `subscription OnCreateUser($filter: ModelSubscriptionUserFilterInput) {
  onCreateUser(filter: $filter) {
    address
    email
    referralId
    avatar
    profileName
    publicKey
    publicSigningKey
    metadata
    orgId
    orgRole
    _ttl
    createdAt
    updatedAt
    organisationUsersId
    __typename
  }
}
`;
exports.onUpdateUser = `subscription OnUpdateUser($filter: ModelSubscriptionUserFilterInput) {
  onUpdateUser(filter: $filter) {
    address
    email
    referralId
    avatar
    profileName
    publicKey
    publicSigningKey
    metadata
    orgId
    orgRole
    _ttl
    createdAt
    updatedAt
    organisationUsersId
    __typename
  }
}
`;
exports.onDeleteUser = `subscription OnDeleteUser($filter: ModelSubscriptionUserFilterInput) {
  onDeleteUser(filter: $filter) {
    address
    email
    referralId
    avatar
    profileName
    publicKey
    publicSigningKey
    metadata
    orgId
    orgRole
    _ttl
    createdAt
    updatedAt
    organisationUsersId
    __typename
  }
}
`;
exports.onCreateStorage = `subscription OnCreateStorage($filter: ModelSubscriptionStorageFilterInput) {
  onCreateStorage(filter: $filter) {
    address
    cloud_audio
    cloud_documents
    cloud_notes
    cloud_other
    cloud_photos
    cloud_storage_available
    cloud_storage_total
    cloud_video
    audio
    documents
    notes
    other
    photos
    video
    storage_available
    storage_total
    u_balance
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.onUpdateStorage = `subscription OnUpdateStorage($filter: ModelSubscriptionStorageFilterInput) {
  onUpdateStorage(filter: $filter) {
    address
    cloud_audio
    cloud_documents
    cloud_notes
    cloud_other
    cloud_photos
    cloud_storage_available
    cloud_storage_total
    cloud_video
    audio
    documents
    notes
    other
    photos
    video
    storage_available
    storage_total
    u_balance
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.onDeleteStorage = `subscription OnDeleteStorage($filter: ModelSubscriptionStorageFilterInput) {
  onDeleteStorage(filter: $filter) {
    address
    cloud_audio
    cloud_documents
    cloud_notes
    cloud_other
    cloud_photos
    cloud_storage_available
    cloud_storage_total
    cloud_video
    audio
    documents
    notes
    other
    photos
    video
    storage_available
    storage_total
    u_balance
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.onCreateUtoken = `subscription OnCreateUtoken($filter: ModelSubscriptionUtokenFilterInput) {
  onCreateUtoken(filter: $filter) {
    address
    balance
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.onUpdateUtoken = `subscription OnUpdateUtoken($filter: ModelSubscriptionUtokenFilterInput) {
  onUpdateUtoken(filter: $filter) {
    address
    balance
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.onDeleteUtoken = `subscription OnDeleteUtoken($filter: ModelSubscriptionUtokenFilterInput) {
  onDeleteUtoken(filter: $filter) {
    address
    balance
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.onCreatePaymentTransaction = `subscription OnCreatePaymentTransaction(
  $filter: ModelSubscriptionPaymentTransactionFilterInput
) {
  onCreatePaymentTransaction(filter: $filter) {
    cart {
      amount
      currency
      priceId
      productId
      promo
      storage
      __typename
    }
    createdAt
    invoiceNumber
    paidAt
    paymentIntentId
    owner
    receiptNumber
    status
    updatedAt
    __typename
  }
}
`;
exports.onUpdatePaymentTransaction = `subscription OnUpdatePaymentTransaction(
  $filter: ModelSubscriptionPaymentTransactionFilterInput
) {
  onUpdatePaymentTransaction(filter: $filter) {
    cart {
      amount
      currency
      priceId
      productId
      promo
      storage
      __typename
    }
    createdAt
    invoiceNumber
    paidAt
    paymentIntentId
    owner
    receiptNumber
    status
    updatedAt
    __typename
  }
}
`;
exports.onDeletePaymentTransaction = `subscription OnDeletePaymentTransaction(
  $filter: ModelSubscriptionPaymentTransactionFilterInput
) {
  onDeletePaymentTransaction(filter: $filter) {
    cart {
      amount
      currency
      priceId
      productId
      promo
      storage
      __typename
    }
    createdAt
    invoiceNumber
    paidAt
    paymentIntentId
    owner
    receiptNumber
    status
    updatedAt
    __typename
  }
}
`;
exports.onCreateOrganisation = `subscription OnCreateOrganisation(
  $filter: ModelSubscriptionOrganisationFilterInput
) {
  onCreateOrganisation(filter: $filter) {
    id
    subdomain
    name
    logoBase64
    primaryColor
    secondaryColor
    owner
    email
    users {
      items {
        address
        email
        referralId
        avatar
        profileName
        publicKey
        publicSigningKey
        metadata
        orgId
        orgRole
        _ttl
        createdAt
        updatedAt
        organisationUsersId
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.onUpdateOrganisation = `subscription OnUpdateOrganisation(
  $filter: ModelSubscriptionOrganisationFilterInput
) {
  onUpdateOrganisation(filter: $filter) {
    id
    subdomain
    name
    logoBase64
    primaryColor
    secondaryColor
    owner
    email
    users {
      items {
        address
        email
        referralId
        avatar
        profileName
        publicKey
        publicSigningKey
        metadata
        orgId
        orgRole
        _ttl
        createdAt
        updatedAt
        organisationUsersId
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.onDeleteOrganisation = `subscription OnDeleteOrganisation(
  $filter: ModelSubscriptionOrganisationFilterInput
) {
  onDeleteOrganisation(filter: $filter) {
    id
    subdomain
    name
    logoBase64
    primaryColor
    secondaryColor
    owner
    email
    users {
      items {
        address
        email
        referralId
        avatar
        profileName
        publicKey
        publicSigningKey
        metadata
        orgId
        orgRole
        _ttl
        createdAt
        updatedAt
        organisationUsersId
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.onCreateApiKey = `subscription OnCreateApiKey($filter: ModelSubscriptionApiKeyFilterInput) {
  onCreateApiKey(filter: $filter) {
    key
    address
    user {
      address
      email
      referralId
      avatar
      profileName
      publicKey
      publicSigningKey
      metadata
      orgId
      orgRole
      _ttl
      createdAt
      updatedAt
      organisationUsersId
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.onUpdateApiKey = `subscription OnUpdateApiKey($filter: ModelSubscriptionApiKeyFilterInput) {
  onUpdateApiKey(filter: $filter) {
    key
    address
    user {
      address
      email
      referralId
      avatar
      profileName
      publicKey
      publicSigningKey
      metadata
      orgId
      orgRole
      _ttl
      createdAt
      updatedAt
      organisationUsersId
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.onDeleteApiKey = `subscription OnDeleteApiKey($filter: ModelSubscriptionApiKeyFilterInput) {
  onDeleteApiKey(filter: $filter) {
    key
    address
    user {
      address
      email
      referralId
      avatar
      profileName
      publicKey
      publicSigningKey
      metadata
      orgId
      orgRole
      _ttl
      createdAt
      updatedAt
      organisationUsersId
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.onCreateWebhook = `subscription OnCreateWebhook($filter: ModelSubscriptionWebhookFilterInput) {
  onCreateWebhook(filter: $filter) {
    id
    url
    address
    user {
      address
      email
      referralId
      avatar
      profileName
      publicKey
      publicSigningKey
      metadata
      orgId
      orgRole
      _ttl
      createdAt
      updatedAt
      organisationUsersId
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.onUpdateWebhook = `subscription OnUpdateWebhook($filter: ModelSubscriptionWebhookFilterInput) {
  onUpdateWebhook(filter: $filter) {
    id
    url
    address
    user {
      address
      email
      referralId
      avatar
      profileName
      publicKey
      publicSigningKey
      metadata
      orgId
      orgRole
      _ttl
      createdAt
      updatedAt
      organisationUsersId
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.onDeleteWebhook = `subscription OnDeleteWebhook($filter: ModelSubscriptionWebhookFilterInput) {
  onDeleteWebhook(filter: $filter) {
    id
    url
    address
    user {
      address
      email
      referralId
      avatar
      profileName
      publicKey
      publicSigningKey
      metadata
      orgId
      orgRole
      _ttl
      createdAt
      updatedAt
      organisationUsersId
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.onCreateWebhookLog = `subscription OnCreateWebhookLog(
  $filter: ModelSubscriptionWebhookLogFilterInput
) {
  onCreateWebhookLog(filter: $filter) {
    id
    url
    address
    event
    requestBody
    responseBody
    responseStatusCode
    createdAt
    deliveryStatus
    updatedAt
    __typename
  }
}
`;
exports.onUpdateWebhookLog = `subscription OnUpdateWebhookLog(
  $filter: ModelSubscriptionWebhookLogFilterInput
) {
  onUpdateWebhookLog(filter: $filter) {
    id
    url
    address
    event
    requestBody
    responseBody
    responseStatusCode
    createdAt
    deliveryStatus
    updatedAt
    __typename
  }
}
`;
exports.onDeleteWebhookLog = `subscription OnDeleteWebhookLog(
  $filter: ModelSubscriptionWebhookLogFilterInput
) {
  onDeleteWebhookLog(filter: $filter) {
    id
    url
    address
    event
    requestBody
    responseBody
    responseStatusCode
    createdAt
    deliveryStatus
    updatedAt
    __typename
  }
}
`;
exports.onCreateKeyMetric = `subscription OnCreateKeyMetric($filter: ModelSubscriptionKeyMetricFilterInput) {
  onCreateKeyMetric(filter: $filter) {
    available_funds
    createdAt
    daily_arweave_uploads
    daily_audio_uploads
    daily_audio_uploads_size
    daily_banned_uploads
    daily_blocked_uploads
    daily_churn
    daily_cloud_uploads
    daily_committed_storage
    daily_committed_uploads
    daily_committed_uploads_duration
    daily_documents_uploads
    daily_documents_uploads_size
    daily_expenses_eur
    daily_invites_accepted
    daily_invites_sent
    daily_ipfs_uploads
    daily_memos
    daily_new_users
    daily_other_uploads
    daily_other_uploads_size
    daily_payments
    daily_pending_uploads
    daily_photos_uploads
    daily_photos_uploads_size
    daily_rejected_uploads
    daily_reposted_twice_uploads
    daily_reposted_uploads
    daily_revenue_eur
    daily_scheduled_uploads
    daily_transactions
    daily_uploads
    daily_uploads_size
    daily_used_storage
    daily_users_activity {
      location
      users_count
      __typename
    }
    daily_vaults
    daily_video_uploads
    daily_video_uploads_size
    date
    id
    monthly_active_users_count
    monthly_active_users_list
    total_active_users
    total_arweave_uploads
    total_audio_uploads
    total_audio_uploads_size
    total_banned_uploads
    total_blocked_uploads
    total_cloud_uploads
    total_committed_storage
    total_committed_uploads
    total_documents_uploads
    total_documents_uploads_size
    total_expenses_eur
    total_inactive_users
    total_invites_sent
    total_invites_unaccepted
    total_ipfs_uploads
    total_memos
    total_other_uploads
    total_other_uploads_size
    total_payments
    total_pending_uploads
    total_photos_uploads
    total_photos_uploads_size
    total_rejected_uploads
    total_reposted_twice_uploads
    total_reposted_uploads
    total_revenue_eur
    total_scheduled_uploads
    total_transactions
    total_uploads
    total_uploads_size
    total_used_storage
    total_vaults
    total_video_uploads
    total_video_uploads_size
    updatedAt
    __typename
  }
}
`;
exports.onUpdateKeyMetric = `subscription OnUpdateKeyMetric($filter: ModelSubscriptionKeyMetricFilterInput) {
  onUpdateKeyMetric(filter: $filter) {
    available_funds
    createdAt
    daily_arweave_uploads
    daily_audio_uploads
    daily_audio_uploads_size
    daily_banned_uploads
    daily_blocked_uploads
    daily_churn
    daily_cloud_uploads
    daily_committed_storage
    daily_committed_uploads
    daily_committed_uploads_duration
    daily_documents_uploads
    daily_documents_uploads_size
    daily_expenses_eur
    daily_invites_accepted
    daily_invites_sent
    daily_ipfs_uploads
    daily_memos
    daily_new_users
    daily_other_uploads
    daily_other_uploads_size
    daily_payments
    daily_pending_uploads
    daily_photos_uploads
    daily_photos_uploads_size
    daily_rejected_uploads
    daily_reposted_twice_uploads
    daily_reposted_uploads
    daily_revenue_eur
    daily_scheduled_uploads
    daily_transactions
    daily_uploads
    daily_uploads_size
    daily_used_storage
    daily_users_activity {
      location
      users_count
      __typename
    }
    daily_vaults
    daily_video_uploads
    daily_video_uploads_size
    date
    id
    monthly_active_users_count
    monthly_active_users_list
    total_active_users
    total_arweave_uploads
    total_audio_uploads
    total_audio_uploads_size
    total_banned_uploads
    total_blocked_uploads
    total_cloud_uploads
    total_committed_storage
    total_committed_uploads
    total_documents_uploads
    total_documents_uploads_size
    total_expenses_eur
    total_inactive_users
    total_invites_sent
    total_invites_unaccepted
    total_ipfs_uploads
    total_memos
    total_other_uploads
    total_other_uploads_size
    total_payments
    total_pending_uploads
    total_photos_uploads
    total_photos_uploads_size
    total_rejected_uploads
    total_reposted_twice_uploads
    total_reposted_uploads
    total_revenue_eur
    total_scheduled_uploads
    total_transactions
    total_uploads
    total_uploads_size
    total_used_storage
    total_vaults
    total_video_uploads
    total_video_uploads_size
    updatedAt
    __typename
  }
}
`;
exports.onDeleteKeyMetric = `subscription OnDeleteKeyMetric($filter: ModelSubscriptionKeyMetricFilterInput) {
  onDeleteKeyMetric(filter: $filter) {
    available_funds
    createdAt
    daily_arweave_uploads
    daily_audio_uploads
    daily_audio_uploads_size
    daily_banned_uploads
    daily_blocked_uploads
    daily_churn
    daily_cloud_uploads
    daily_committed_storage
    daily_committed_uploads
    daily_committed_uploads_duration
    daily_documents_uploads
    daily_documents_uploads_size
    daily_expenses_eur
    daily_invites_accepted
    daily_invites_sent
    daily_ipfs_uploads
    daily_memos
    daily_new_users
    daily_other_uploads
    daily_other_uploads_size
    daily_payments
    daily_pending_uploads
    daily_photos_uploads
    daily_photos_uploads_size
    daily_rejected_uploads
    daily_reposted_twice_uploads
    daily_reposted_uploads
    daily_revenue_eur
    daily_scheduled_uploads
    daily_transactions
    daily_uploads
    daily_uploads_size
    daily_used_storage
    daily_users_activity {
      location
      users_count
      __typename
    }
    daily_vaults
    daily_video_uploads
    daily_video_uploads_size
    date
    id
    monthly_active_users_count
    monthly_active_users_list
    total_active_users
    total_arweave_uploads
    total_audio_uploads
    total_audio_uploads_size
    total_banned_uploads
    total_blocked_uploads
    total_cloud_uploads
    total_committed_storage
    total_committed_uploads
    total_documents_uploads
    total_documents_uploads_size
    total_expenses_eur
    total_inactive_users
    total_invites_sent
    total_invites_unaccepted
    total_ipfs_uploads
    total_memos
    total_other_uploads
    total_other_uploads_size
    total_payments
    total_pending_uploads
    total_photos_uploads
    total_photos_uploads_size
    total_rejected_uploads
    total_reposted_twice_uploads
    total_reposted_uploads
    total_revenue_eur
    total_scheduled_uploads
    total_transactions
    total_uploads
    total_uploads_size
    total_used_storage
    total_vaults
    total_video_uploads
    total_video_uploads_size
    updatedAt
    __typename
  }
}
`;
